export const cmsDefaults = [
  {
    tool: 'DXPGlobal',
    key: 'Account.Details.Parent.Portfolio.Code.txt',
    value: 'The reference code of the portfolio which this account belongs to.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Details.Parent.Portfolio.Name.txt',
    value: 'The name of the portfolio which this account belongs to.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Details.Service.level.txt',
    value: 'Investment management service that the account is invested into.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Details.Valuation.Currency.txt',
    value:
      "The currency used to summarise values for this account. Some holdings may be in a different currency and will be converted into the account's valuation currency.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Summary.BookCostTotal.Info.Text',
    value:
      'The aggregated cost of the securities and assets at the time they were bought.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Summary.CurrentValueTotal.Info.Text',
    value: 'This represents the current total value of all your accounts.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Transactions.Download.AllTransactionsRadio.Text',
    value: 'ALL data',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Transactions.Download.CashFilteredWarning.Text',
    value:
      'You will only download data for the type and currency you are currently viewing.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Transactions.Download.FilteredTransactionsRadio.Text',
    value: 'Filtered data',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Transactions.Download.FilteredWarning.Text',
    value:
      'You currently have filters applied to the transactions. Do you want to download all data or only the filtered data?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Transactions.Download.Info.Text',
    value: 'This data will be downloaded as a .csv file.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Transactions.NoResults.Body.Text',
    value:
      'We are unable to show you any transactions. <br />If you have used filtering, please expand your search criteria. <br />If you think you should see results, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Account.Valuation.LessThan3MonthsData.Alert.Text',
    value:
      'Please remember that these are long-term investments. As your account is less than three months old, any gains or losses at this stage may not reflect longer-term trends.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Block.SuccessMessage.Text',
    value: 'User blocked. Changes may take a moment to show.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.ClientDetails.PaperlessPref.Message',
    value:
      'Warning: You should only update a client&rsquo;s paperless preference on their behalf in exceptional circumstances as they can make this change themselves. You should check the client is registered for the portal before moving them to paperless.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.ClientDetails.PaperlessPref.Warning.Text',
    value:
      'Please note that this client&rsquo;s contact preference is currently set to <strong>Paperless</strong>. If you delete this email address it will automatically default to <strong>Paper</strong>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.DeactivateUser.SuccessMessage.Text',
    value: 'User deactivated. Status may take a moment to update.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Employee.InvalidEmail.Message',
    value:
      'You cannot unblock an employee who does not have a valid email address and/or mobile number as these details are required for security purposes.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Firms.Employees.Permissions.Info',
    value:
      'You can only manage an employee&rsquo;s&nbsp;<strong>online permissions</strong> through the admin portal.<br /><strong>Client access links must be updated in Figaro</strong>, and any changes made there may take <strong>up to 24 hours</strong> to reflect in the digital system.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Invite.SuccessMessage.Text',
    value: 'Invite sent successfully. Status will update shortly.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteClient.IncorrectDetails.Message',
    value:
      '<p>Please contact the records team <a href="mailto:borecords@quiltercheviot.com">borecords@quiltercheviot.com</a> to update the details before registering the client.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteClient.InvalidEmail.Message',
    value:
      '<p>You cannot invite this client to register as they do not have a valid email address. Please contact the records team <a href="mailto:borecords@quiltercheviot.com">borecords@quiltercheviot.com</a> to update the details before registering the client.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteClient.InvalidPhone.Message',
    value:
      '<p>You cannot invite this client to register as they do not have a valid mobile number. Please contact the records team <a href="mailto:borecords@quiltercheviot.com">borecords@quiltercheviot.com</a> to update the details before registering the client.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.IncorrectDetails.Message',
    value:
      'Please contact the records team <a href="mailto:borecords@quiltercheviot.com">borecords@quiltercheviot.com</a> to update the details before registering the employee.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.InvalidEmail.Message',
    value:
      'You cannot invite this employee to register as they do not have a valid email address. Please contact the records team <a href="mailto:borecords@quiltercheviot.com">borecords@quiltercheviot.com</a> to update the details before registering the employee.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.InvalidPhone.Message',
    value:
      'You cannot invite this employee to register as they do not have a valid mobile number. Please contact the records team <a href="mailto:borecords@quiltercheviot.com">borecords@quiltercheviot.com</a> to update the details before registering the employee.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.Permissions.AccessConfirmation.InformationMessage',
    value:
      "<strong>WARNING</strong>: Please ensure that the employee's access to the firms listed below is correct.<br /><br />If they are a master user or a non-adviser, they will have access to <strong>all</strong> client data of the selected firms. Additionally, if they have access to networks, they will gain access to <strong>all</strong> client data of <strong>all</strong> underlying firms within the selected network.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.Permissions.AccessConfirmation.NoPermissionsMessage',
    value:
      'You cannot invite this firm employee to register as they do not have a valid link to any firm or network. Please review their access links within Figaro before attempting to invite them to register.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.Permissions.AccessConfirmation.NotCorrectMessage',
    value:
      "Please correct the employee's access links in Figaro and wait for the data to be updated in the digital system before attempting to invite them again. This process can take up to 1 day.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.Permissions.AccessConfirmation.Title',
    value: "Confirm the employee's access",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.Permissions.Fees.InfoTooltip',
    value:
      'Grants the employee access to view all fee-related data for the clients the employee is permitted to access. If access is granted at the network or firm of firms level, it automatically includes all underlying firms',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.Permissions.Fees.Title',
    value: 'Set permissions - Fees',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.Permissions.Reports.InfoTooltip',
    value:
      'Grants the employee the ability to download all available client reports for the client data they have access to',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.InviteEmployee.Permissions.Reports.Title',
    value: 'Set permissions - Reports',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Passkeys.List.Body',
    value: 'You can only delete these Passkeys, you are unable to edit them.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Passkeys.List.Empty.Text',
    value: 'This user has not set up any passkeys.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Reports.OnlineAccount.Information.Text',
    value:
      'A report showing all users with an online account who have either registered online or been migrated.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Reports.QuarterlyDistributionList.Information.Text',
    value:
      "A report showing all active clients and the following information:\n<ul>\n<li>Client name and partial mobile number</li>\n<li>Client email address</li>\n<li>Their investment manager's details</li>\n</ul>",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Reports.MonthlyLogin.Information.Text',
    value:
      'Shows the total number of web and mobile app logins, grouped by user type and month for the selected time period.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Reports.MobileAppLogin.Information.Text',
    value:
      'Shows the running total of unique clients who have logged into the mobile app during the selected time period. Each client is counted once, regardless of how many times they log in.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Reports.IndiviudalUserLogin.Information.Text',
    value:
      'Shows the total number of logins for each individual user, broken down by month. Includes adviser and Corporate Client Portal users.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Reports.MonthlyUniqueAdvAndCorpLogins.Information.Text',
    value:
      'Shows unique Adviser and Corporate Client Portal logins by user type, login type, and month, with login counts totalled for each group.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Reports.BusinessEventLogs.Information.Text',
    value:
      'Download a report of all the business event logs within a defined date range.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Unblock.SuccessMessage.Text',
    value: 'User unblocked. Changes may take a moment to show.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Unblockreason.Client.Text',
    value:
      'You are about to unblock a clients&rsquo; account. They will be reinstated with the same permissions and links that they had previously.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.Unblockreason.Employee.Text',
    value:
      "You are about to unblock an employees' account. They will be reinstated with the same permissions and links that they had previously.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.UpdateEmail.Message',
    value:
      'Please be aware that updating this email won&rsquo;t change the username. If the username is the same as the email address and the user wants it updated, you also need to edit their username.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Admin.UpdateUsername.SuccessMessage.Text',
    value: 'Username updated. Changes may take a moment to show.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Block.SuccessMessage.Text',
    value: 'User blocked. Changes may take a moment to show.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.CancelModal.BackToForm',
    value: 'Back to the form',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.CancelModal.ConfirmCancel',
    value: 'Yes, cancel',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.CancelModal.Content',
    value:
      'If you decide to cancel, any information you have entered will be lost.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.CancelModal.Title',
    value: 'Are you sure you want to cancel?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.ClientSearch.CannotCalculateTotal.Text',
    value:
      'We are unable to calculate the total value of your assets at this time due to missing information. Please try again later, and if the issue continues, please contact us.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.ClientSearchTable.Entity.NoResults',
    value:
      'We could not find a trust, charity or other client corporation that matches your search.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.ClientSearchTable.Individual.NoResults',
    value: 'We could not find a client that matches your search.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.ClientSearch.TotalValueOfAssets.Text',
    value:
      'This total includes all portfolios you have permission to view. If a portfolio is linked to more than one client or entity, it is counted only once.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.ClientSearchTable.Toggle.Info',
    value:
      'Clients are individuals.<br />Entities are companies, charities or trusts.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.DeactivateUser.SuccessMessage.Text',
    value: 'User deactivated. Status may take a moment to update.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employee.InvalidEmail.Message',
    value:
      'You cannot unblock an employee who does not have a valid email address and/or mobile number as these details are required for security purposes.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employee.UpdateEmail.Warning.Text',
    value:
      'Please be aware that updating this email won\'t change the username. If the username is the same as the email address and you need to update it, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.DeactivateEmployee.Message.Error',
    value:
      'Deactivation failed. Please try again or contact us if the issue persists.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.DeactivateEmployee.Message.Success',
    value: 'This employee has now been deactivated',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.DeactivateEmployee.RightsToOtherFirms.Warning',
    value:
      'You cannot deactivate this employee due to them having access to one or more firms or networks that you are not a master user of.<br /><br />Please contact <strong>Quilter Cheviot</strong> at <a href="mailto:qcadvisersupport@quiltercheviot.com"><strong>qcadvisersupport@quiltercheviot.com</strong></a><br />for assistance with deactivating this employee.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.DeactivateEmployee.Warning.Body',
    value:
      '<p>Deactivating this employee&rsquo;s account will remove their online access and permissions.</p>\n<ul>\n<li>If the employee is a <strong>financial adviser</strong>, only their <strong>online account and permissions</strong> will be removed; their client access links will remain unaffected.</li>\n<li>If the employee is a <strong>non-adviser</strong>, this action will also remove <strong>all client access links</strong>, and they will become inactive.</li>\n</ul>\n<p>Please provide a reason why you want to deactivate the employee if you wish to proceed.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.DeactivateEmployee.Warning.Title',
    value: "Warning: Deactivating this employee's account",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.Permissions.Info',
    value:
      'You can manage both client access links and permissions for employees who are not financial advisers or master users.&nbsp;<br /><br />For employees who are either a financial adviser or a master user, you can only manage their permissions but not their client access links.&nbsp;<br /><br />To update their client access or change their master user status, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.Permissions.MissingLink',
    value:
      'The employee you are trying to review has access to one or more firms or networks that you are not a master user of. As a result, you cannot review their access.<br /><br />For data protection reasons, we are unable to display or share these access details with you.<br /><br />Please contact us our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a> for assistance in resolving this issue.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.Permissions.NoLinks',
    value:
      'The employee does not currently have access to any firms or networks.<br /><br />As a result, you cannot proceed, as there are no access links to view.<br /><br />Please first <strong>update the employee\'s firm and network access links</strong> by contacting the Third party relationship management team at <a href="mailto:qcadvisersupport@quiltercheviot.com">qcadvisersupport@quiltercheviot.com</a> to review and update their access links within Figaro.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Employees.Permissions.RemoveAll.Error',
    value:
      'You cannot save these changes as an employee always requires client access to at least 1 firm or network to remain active.<br /><br />If you wish to remove all client access please consider &ldquo;<strong>Deactivating</strong>&rdquo; the employee instead.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Firms.Employees.Table.MasterStatus.Info',
    value:
      'A master user can manage users for the firm, network, or corporate they are currently viewing.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Individual.Account.Details.OnlineAccountStatus.Info',
    value: "This shows the current status of the individual's online account",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Individual.Account.Details.PersonStatuses.Info',
    value: 'The status of the client that we hold on the investment platform.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Individual.Account.Details.TaxTypeReferences.Info',
    value:
      'The country and type of the tax identification number as well as the number itself.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Individual.Account.Details.TotalValueCurrency.Info',
    value:
      'The total valuation of the client&rsquo;s holdings that are linked to the adviser.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InvestmentSummary.ClientView.ExcludedPortfolios.Text',
    value:
      'The below values do not include any portfolios excluded by the client from their valuation total.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Invite.SuccessMessage.Text',
    value: 'Invite sent successfully. Status will update shortly.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteEmployee.ConfirmAccess.InfoMessage',
    value:
      "<strong>WARNING</strong>: Please ensure that the employee's access to the firms listed below is correct.<br /><br />If they are a master user or a non-adviser, they will have access to <strong>all</strong> client data of the selected firms. Additionally, if they have access to networks, they will gain access to <strong>all</strong> client data of <strong>all</strong> underlying firms within the selected network.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteEmployee.ConfirmAccess.MasterUserInfo',
    value:
      'This employee has additional rights to manage user access for other employees within the firms they are linked to.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteEmployee.ConfirmAccess.Title',
    value: "Confirm the employee's access",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteEmployee.ConfirmAccess.Warning',
    value:
      'Please first attempt to correct the employee\'s <strong>firm links</strong> on the employee details page under the "Access &amp; Permissions" tab before proceeding to send the registration invite.<br /><br />If you are unable to update the employee\'s access links, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a> to edit the access links.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteEmployee.Fees.PermissionInfoTooltip',
    value:
      'Grants the employee access to view all fee-related data for the clients the employee is permitted to access.<br /><br />If access is granted at the network or firm of firms level, it automatically includes all underlying firms.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteEmployee.Fees.Title',
    value: 'Set permissions - Fees',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteEmployee.Reports.PermissionInfoTooltip',
    value:
      'Grants the employee the ability to download all available client reports for the client data they have access to.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteEmployee.Reports.Title',
    value: 'Set permissions - Reports',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteFirmEmployee.Cancel.Message',
    value: 'Cancel without saving',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteFirmEmployee.Continue.Message',
    value: 'CONTINUE',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteFirmEmployee.Description.Message',
    value:
      'Before sending the registration invite, can you please confirm that the following details for the employee are correct',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteFirmEmployee.Failure.Message',
    value:
      'The request to send an invite has failed, please try again in 10 mins.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteFirmEmployee.IncorrectDetails.Message',
    value:
      'Please update the employee&rsquo;s email address or mobile number to the correct one before attempting to send the invitation.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteFirmEmployee.InvalidEmail.Message',
    value:
      '<strong>Error: </strong>You cannot invite this firm employee to register because <strong>they do not have a valid email address.</strong> Please update their email address to a valid one before attempting to send the invitation.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteFirmEmployee.InvalidPhone.Message',
    value:
      '<strong>Error: </strong>You cannot invite this firm employee to register because <strong>they do not have a valid mobile number.</strong> Please update their mobile number to a valid one before attempting to send the invitation.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.InviteFirmEmployee.Title.Message',
    value: 'Send employee invitation to register',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Navigation.MarketingPreferences.Link.Link',
    value:
      'https://www.quiltercheviot.com/news-and-events/subscribe-to-a-newsletter/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Navigation.MarketingPreferences.Link.Text',
    value: 'Marketing preferences',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.AssignAccess.CreateButtonLabel',
    value: 'CREATE',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.AssignAccess.InfoBoxFooter',
    value:
      'Creating this employee will not automatically send a registration email. You can do this on the next page, the employee profile page.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.AssignAccess.InfoBoxHeader',
    value:
      '<strong>WARNING</strong>: Please ensure that the employee access being granted is correct, as this will enable access to <strong>all</strong> client data of the firms selected below. Additionally, if employee access is granted to networks or firms of firms, they will gain access to <strong>all</strong> client data of all underlying firms within the selected network or firm of firms.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.AssignAccess.PageTitle',
    value: 'Set new employee client access',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.AssignAccess.UnselectableFirmsInfoTooltip',
    value:
      'You are not a master user of this firm or network, so you cannot directly grant access to the new employee. However, if you are the master user of this network, you can grant access. This will automatically provide access to all firms within that network.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.CancelModal.Button.BackToForm',
    value: 'Back to the form',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.CancelModal.Button.ConfirmCancel',
    value: 'Yes, cancel',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.CancelModal.Message',
    value:
      'If you decide to cancel, any information you have entered will be lost.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.CancelModal.Title',
    value: 'Are you sure you want to cancel?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.EmployeeTypePage.Button.Cancel',
    value: 'Cancel without saving',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.EmployeeTypePage.Button.Continue',
    value: 'CONTINUE',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.EmployeeTypePage.Definitions.AdviserMasterUser',
    value:
      '<ul>\n<li><strong>Adviser:</strong> This employee is a regulated financial adviser.</li>\n<li><strong>Master user:</strong> This employee can be either a non-adviser or adviser with additional rights to manage user access for other employees.</li>\n</ul>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.EmployeeTypePage.Definitions.NonAdviser',
    value:
      '<strong>Non-adviser:</strong> This employee is not a financial adviser but requires online access to client data for administrative purposes. Examples include office managers, administrators and paraplanners.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.EmployeeTypePage.InfoMessage',
    value:
      '<strong>Important:</strong> Before creating a new employee, please ensure they do not already exist in the system by searching for them on the search page to avoid creating duplicates.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.EmployeeTypePage.Title',
    value: 'What type of new employee are you setting up?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.EmployeeTypePage.Warning.AdviserRestricted',
    value:
      '<p><strong>You cannot create an adviser or master user within the system.</strong></p>\n<p>These types of employees must be created by Quilter Cheviot. Please contact us our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a> with the details of the new employee you wish to create within the system.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.NonAdviserDetailsPage.Button.Back',
    value: 'BACK',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.NonAdviserDetailsPage.Title',
    value: 'Enter your new non-adviser employee details',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.NewEmployee.NonAdviserDetailsPage.ValidationMessage',
    value: 'Please ensure all fields are completed and valid',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Portfolio.Details.Excluded.From.Total.Value',
    value: 'The client has portfolios excluded from this total.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Registration.Welcome.Body.Text',
    value:
      "<p>We're pleased to have you here. Creating your account is straightforward. Here's what you can expect from the registration process:</p>\n<ol>\n<li><strong>Agree to our Online Services Terms &amp; Conditions</strong>: Review and accept our terms to proceed.</li>\n<li><strong>Create your username</strong>: Enter your chosen username. Your username can be an email address, but it doesn&rsquo;t have to be.</li>\n<li><strong>Create your password</strong>: You&rsquo;ll find a hint on the password entry screen to help you decide on a secure password.</li>\n<li><strong>Enter one-time code</strong>: For security purposes, you&rsquo;ll need to enter a one-time code sent to your mobile number.</li>\n</ol>\nOnce you've completed these steps and chosen your credentials, you'll receive an email confirming your account registration. You'll can then log in with these credentials at any time.<br /><br /><strong>Let's get started!</strong>",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Reporting.Options.FeeReport',
    value: 'Fee report',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Reporting.Options.FeeReport.Description',
    value:
      'This will generate a .csv file containing fee transactions for the firms or networks that you have permission to view and for the date range you have selected within <strong>the last 5 years</strong>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Reporting.Options.ValuationReport',
    value: 'Valuation report',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Reporting.Options.ValuationReport.Description',
    value:
      'This will generate a .csv file containing the current value of all assets held by the clients that you have permissions to view.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.Unblock.SuccessMessage.Text',
    value: 'User unblocked. Changes may take a moment to show.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.UserManagement.Employees.Info.Adviser.Text',
    value: 'Is this employee a registered financial adviser?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.UserManagement.Employees.Info.Company.Text',
    value: 'The company that this employee is linked to.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.UserManagement.Employees.Info.FirmNetwork.Text',
    value: 'The firms or networks this employee has direct links to.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.UserManagement.Employees.NoResults.Text',
    value: 'We could not find an employee that matches your search.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Adviser.UserManagement.FirmsNetworks.NoResults.Text',
    value: 'We could not find any firms that match your search.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link0.Link',
    value: 'https://www.quiltercheviot.com/contact-us/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link0.Text',
    value: 'Contact Quilter Cheviot',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link1.Link',
    value:
      'https://www.quiltercheviot.com/supporting-clients-with-additional-needs/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link1.Text',
    value: 'Supporting clients with additional needs',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link2.Link',
    value: 'https://www.quiltercheviot.com/myqc/support',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link2.Text',
    value: 'Frequently Asked Questions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link3.Link',
    value:
      'https://www.quiltercheviot.com/siteassets/documents/terms-and-conditions/qc-online-services-terms-and-conditions.pdf',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link3.Text',
    value: 'Online Services Terms & Conditions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link4.Link',
    value: 'https://www.quiltercheviot.com/online-services-cookies-notice/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link4.Text',
    value: 'Online Services cookies notice',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link5.Link',
    value:
      'https://www.quiltercheviot.com/important-information/privacy-notice/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link5.Text',
    value: 'Privacy notice',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link6.Link',
    value:
      'https://www.quiltercheviot.com/important-information/corporate-and-regulatory-information/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link6.Text',
    value: 'Corporate and regulatory information',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link7.Link',
    value:
      'https://www.quiltercheviot.com/important-information/accessibility/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'App.Navigation.Footer.Link7.Text',
    value: 'Accessibility',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Asset.Summary.TableHeader.Info.Text',
    value:
      'This table shows the list of assets you hold, categorised at different asset class levels.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'AssetClasses.Details.TableHeader.Income.Info.Text',
    value:
      'The return on an investment by way of a dividend on shares or interest on bonds or cash.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'AssetClasses.Details.TableHeader.Performance.Info.Text',
    value:
      'The gain or loss made by each asset based on the amount paid for the investment in comparison to the current value.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'AssetClasses.Details.TableHeader.Value.Info.Text',
    value:
      'The current value of each asset you hold calculated as the number of units held multiplied by the price per unit. These are shown in the currency of your portfolio/account.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'AssetClasses.Details.TableHeader.Yield.Info.Text',
    value: 'The estimated income divided by the value.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Assets.Search.NotFound.Text',
    value:
      'We could not find any result matching your search. Please double check your search term.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.PersonalDetails.UpdateEmail.Warning.Text',
    value:
      'Please be aware that updating this email won\'t change the username. If the username is the same as the email address and you need to update it, please contact your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.PortfolioReport.Noassetinvestments.Message',
    value: 'This portfolio is not currently invested in any assets.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.PortfolioReport.Nocashinvestments.Message',
    value: 'This portfolio is not currently invested in any cash.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.PortfolioSummaryReportDateDisclaimer.Message',
    value:
      'The value of your investments and the income from them can fall and you may not recover what you invested. All values are based on the mid-market price at the close of business on the date shown, converted into the valuation currency where appropriate. Prices can be updated intra-day but may not be reflected here until the following day. Quilter Cheviot takes no responsibility for the prices of unquoted, unmarketable or illiquid securities. If you have any questions, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.PortfolioSummaryReportTradingNames.Message',
    value:
      'Quilter Cheviot and Quilter Cheviot Investment Management are trading names of Quilter Cheviot Limited, Quilter Cheviot International Limited and Quilter Cheviot Europe Limited. Quilter Cheviot International is a trading name of Quilter Cheviot International Limited. Quilter Cheviot Limited is registered in England and Wales with number 01923571, registered office at Senator House, 85 Queen Victoria Street, London, EC4V 4AB. Quilter Cheviot Limited is a member of the London Stock Exchange, authorised and regulated by the UK Financial Conduct Authority and as an approved Financial Services Provider by the Financial Sector Conduct Authority in South Africa. Quilter Cheviot International Limited is registered in Jersey with number 128676, registered office at 3rd Floor, Windward House, La Route de la Liberation, St Helier, JE1 1QJ, Jersey and is regulated by the Jersey Financial Services Commission and as an approved Financial Services Provider by the Financial Sector Conduct Authority in South Africa. Quilter Cheviot International Limited has established a branch in the Dubai International Financial Centre (DIFC) with number 2084, registered office at 4th Floor, Office 415, Index Tower, Al Mustaqbal Street, DIFC, PO Box 122180, Dubai, UAE which is regulated by the Dubai Financial Services Authority. Promotions of financial information made by Quilter Cheviot DIFC may be carried out on behalf of its group entities. Quilter Cheviot Europe Limited is regulated by the Central Bank of Ireland, and is registered in Ireland with number 643307, registered office at Hambleden House, 19-26 Lower Pembroke Street, Dublin D02 WV96.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.Report.Noassetinvestments.Message',
    value: 'Not currently invested in any assets',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.Report.Nocashinvestments.Message',
    value: 'Not currently invested in any cash',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ClientPortfolioReport.Button.Text',
    value: 'Generate portfolio report',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ClientPortfolioReport.DateSelection.Header',
    value: 'Generate portfolio report',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ClientPortfolioReport.DateSelection.Text',
    value:
      '<p data-prosemirror-content-type="node" data-prosemirror-node-name="paragraph" data-prosemirror-node-block="true"><strong data-prosemirror-content-type="mark" data-prosemirror-mark-name="strong">Please select a timeframe for your valuation and performance graphs.</strong><br data-prosemirror-content-type="node" data-prosemirror-node-name="hardBreak" data-prosemirror-node-inline="true" />Note: The investments and asset classes shown will always reflect the most recent available data, regardless of the timeframe you choose.</p>\n<p data-prosemirror-content-type="node" data-prosemirror-node-name="paragraph" data-prosemirror-node-block="true">If your downloaded report doesn&rsquo;t open automatically, please check that your browser hasn&rsquo;t blocked pop-ups for this site.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ClientPortfolioReport.DateSelection.Text.Mobile',
    value:
      '<strong>Please select a timeframe for your valuation and performance graphs.</strong><br />Note: The investments and asset classes shown will always reflect the most recent available data, regardless of the timeframe you choose.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ClientReport.Button.Text',
    value: 'Generate client report',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ClientReport.Confirmation.Header',
    value: 'Generate client report',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ClientReport.Confirmation.Text',
    value:
      'The investments and assets included within this report will NOT include any portfolios that have been excluded from the total.&nbsp;\n<div>&nbsp;</div>\n<div>If your downloaded report doesn&rsquo;t open automatically, please check that your browser hasn&rsquo;t blocked pop-ups for this site.</div>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ClientReport.Confirmation.Text.Mobile',
    value:
      'Note: The investments and assets included within this report will NOT include any portfolios that have been excluded from the total.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.App.FeedbackQuestion.Text',
    value:
      "We'd love to hear more about your experience with the Quilter Cheviot app.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Client.App.FeedbackLink.URL',
    value:
      'https://www.surveymonkey.com/r/ZGNMPBP?OS=%5BOS_value%5D&Device=%5BDevice_value%5D&CustomerId=%5BCustomerId_value%5D&AppVersion=%5BAppVersion_value%5D',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Corporate.Employees.Access.Info',
    value:
      'You can manage client access links for employees who are not master users.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Corporate.Employees.Permissions.Info',
    value:
      'You can manage both client access links and permissions for employees who are not master users.&nbsp;<br /><br />For employees who are master users, you can only manage their permissions but not their client access links.&nbsp;<br /><br />To update their client access or change their master user status, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Corporate.Employees.Permissions.RemoveAll.Error',
    value:
      'You cannot save these changes as an employee always requires client access to at least 1 company to remain active.<br /><br />If you wish to remove all client access please consider &ldquo;<strong>Deactivating</strong>&rdquo; the employee instead.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'CorrespondencePreferences.Paperless.Text',
    value:
      'By selecting paperless you can significantly reduce your carbon footprint and we will email you when you have new documents to review.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Email.Footer.Text',
    value:
      '<p><strong data-renderer-mark="true">The value of your investments and the income from them can fall and you may not recover what you invested.</strong><br /><br />This e-mail may contain privileged or confidential information. If you are not the intended recipient of this e-mail, please contact <a href="mailto:marketing@quiltercheviot.com">marketing@quiltercheviot.com</a> immediately and then delete this e-mail and any associated communication regarding this e-mail from your computer. You may not use, copy, distribute or disclose the contents of this e-mail without our consent. Communication by e-mail may not be secure. Quilter plc reserves the right to monitor e-mail communications through its networks. No contract may be concluded on behalf of any group company by e-mail.</p>\n<p>Issued by the Quilter Group of companies which comprises Quilter plc and any subsidiary of Quilter plc from time to time. Further details about the Quilter Group are available at <a href="https://plc.quilter.com/corporate-and-regulatory-information/">https://plc.quilter.com/corporate-and-regulatory-information/</a>. Quilter plc is registered in England and Wales under number 06404270. Registered Office at Senator House, 85 Queen Victoria Street, London, EC4V 4AB, United Kingdom.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Filter.resetfilter.Text',
    value: 'Your current filters have been cleared.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Filter.updatesearchdefaults.Text',
    value: 'Your filter defaults have been updated.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.CashSummary.Table.Capital.Info.Text',
    value: 'Amount of uninvested cash held.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.CashSummary.Table.Income.Info.Text',
    value:
      'Income you have received that has not been withdrawn, transferred or reinvested.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.CashSummary.Table.XdDividendsDue.Info.Text',
    value:
      'Estimated income due but awaiting payment for investments past their ex-dividend date.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.CashSummary.TableHeader.Info.Text',
    value:
      'This table shows a summary of the cash you hold and some key information about that. If you have any questions, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.PercentTotal.Info.Text',
    value:
      'Shows what percentage of the total portfolio(s) or account value each investment represents.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Download.Info.Text',
    value:
      'The data will be downloaded as a .csv file. Cash can be found at the bottom of the file.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.ShowAccruedInterest.Text',
    value:
      'Accrued interest is interest that has built up but hasn&rsquo;t been paid or received yet.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.ShowSubSector.Text',
    value:
      'Sectors consist of multiple subsectors, each representing a more specific part of the overall sector.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableFooter.Income.Info.Text',
    value: 'The total estimated income.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableFooter.Total.Info.Text',
    value: 'Total percentage of your assets excluding cash holdings.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableFooter.Valuation.Info.Text',
    value: 'Total valuation of all assets (excluding cash).',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableFooter.Yield.Info.Text',
    value: 'The estimated total income divided by the total value.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableHeader.BookCost.Info.Text',
    value: 'The cost of the security or asset at the time it was bought.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableHeader.Income.Info.Text',
    value:
      'The estimated return on an investment by way of a dividend on shares or interest on bonds or cash.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableHeader.Info.Text',
    value:
      'This table shows the list of the assets you hold and some key information about each one. If you have any questions, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableHeader.Performance.Info.Text',
    value:
      'The gain or loss made by each asset based on the amount paid for the investment in comparison to the current value.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableHeader.Value.Info.Text',
    value:
      'The current value of each asset you hold calculated as the number of units held multiplied by the price per unit. These are shown in the currency of your portfolio/account.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investment.Summary.TableHeader.Yield.Info.Text',
    value: 'The estimated income divided by the value.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'InvestmentSummary.ClientView.ExcludedPortfolios.Text',
    value:
      'The below values do not include any portfolios excluded from your valuation total.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Investments.Assets.Search.Text',
    value: 'Search by name or SEDOL',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.EnhancedSecurityMessage.Body.Text',
    value:
      'We use industry-leading security experts and software to make sure your data is kept safe. For your security, we may occasionally ask you to re-verify your identity by sending you a one-time code to your registered mobile number.<br /><br />Alternatively, for your peace of mind you can choose to verify your identity this way every time you log-in (see the security settings option in the menu).',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.EnhancedSecurityMessage.Helptray.Cta.Body',
    value:
      'For your security, we may occasionally ask you to re-verify your identity by an additional authentication factor. You can also choose to further enhance your security by opting to verify your identity every time you log-in by enabling the "Enhanced security" setting.<br /><br />If you have both biometrics and the &ldquo;Enhanced security&rdquo; setting enabled while logging into the mobile app you won\'t be required to provide an additional authentication factor when using the app.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.EnhancedSecurityMessage.Helptray.Cta.Text',
    value: 'NEED HELP?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.EnhancedSecurityMessage.Helptray.Cta.Title',
    value: 'Help with enhanced security',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.EnhancedSecurityMessage.Title.Text',
    value: 'Your online security is important',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Helptray.Body',
    value:
      '<strong>Clients:</strong> Simply use your My Quilter Cheviot details to log in. If you have not registered before or cannot remember your username, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> who will be able to set up your personalised access.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user to set up your access or remind you of your username for the My Quilter Cheviot portal. If you are unsure who your master user is, please contact our&nbsp;<a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.<br /><br /><strong>Forgotten password?</strong> If you cannot remember your password, you can use the "Forgot your password?" option once you have entered your username (which is typically your email address).<br /><br />If you need any further help, please view our <a href="https://www.quiltercheviot.com/myqc/support/" target="_blank" rel="noopener">support page</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Helptray.Title',
    value: 'Help with your login',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Passkeys.Body',
    value: 'We are logging you in with your passkey.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Passkeys.Failed.Body',
    value:
      'We could not log you in using your passkey. Try again, or log in with your username and password instead.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Passkeys.Failed.PasswordLogin.Button.Label',
    value: 'Log in with your username and password',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Passkeys.Failed.Retry.Button.Label',
    value: 'Try again',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Passkeys.HelpTray.Body',
    value:
      '<p><strong>Clients:</strong> If you need help logging in, please contact your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/">investment management team</a>. They\'ll be happy to assist.</p>\n<strong>Financial Advisers or Corporate Users:</strong> If you need help logging in, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Passkeys.HelpTray.Button.Label',
    value: 'Need help?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.Passkeys.Title',
    value: 'Logging you in with your passkey',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.RegisterHelptray.Body',
    value:
      '<strong>Clients:</strong> Simply use your My Quilter Cheviot details to log in. If you have not registered before, please speak to your investment manager who will be able to set up your personalised access.<br /><br />You can find your investment manager\'s contact details <a href="https://www.quiltercheviot.com/contact-us/" target="_blank" rel="noopener">here</a>.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user to set up your access for the My Quilter Cheviot portal.<br /><br />If you are unsure who your master user is, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.RegisterHelptray.Title',
    value: 'How To Register',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Body',
    value:
      'Before continuing you will first need to accept our updated Online Services Terms &amp; Conditions. A summary of changes can be found <a href="https://www.quiltercheviot.com/important-information/online-services-terms-conditions-summary/" target="_blank" rel="noopener">here</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Cancel.Cta.Text',
    value: 'Decline and Logout',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Continue.Cta.Text',
    value: 'Accept',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Helptray.Body',
    value:
      'These terms are really important for keeping you safe online.<br /><br />By agreeing to the terms, you confirm that you\'ve read and accepted them. You can then continue using the portal and app.<br /><br />If you don\'t agree to the terms, you won\'t be able to use the portal or app.<br /><br /><strong>Clients:</strong> If you encounter any issues or need assistance, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> for help.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user for assistance or, if you are unsure who your master user is, please contact our&nbsp;<a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Helptray.Cta.Text',
    value: 'Need help?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Helptray.Title',
    value: 'Need help?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Terms.Button.Text',
    value: 'View Online Services Terms &amp; Conditions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Terms.Link',
    value:
      'https://www.quiltercheviot.com/siteassets/documents/terms-and-conditions/qc-online-services-terms-and-conditions.pdf',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Login.TermsOfUse.Title',
    value: 'Online Services Terms &amp; Conditions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Logout.Inactivity.Button.LogOut',
    value: 'LOG OUT',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Logout.Inactivity.Button.StayLoggedIn',
    value: 'STAY LOGGED IN',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Logout.Inactivity.Heading',
    value: 'Still there?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Logout.Inactivity.Message.Body',
    value:
      "You've been inactive for a while. For your security, you'll be logged out in 30 seconds unless you choose to stay logged in.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'MFA.NotYourNumber.Body.Text',
    value:
      'If the mobile number shown on the screen is not correct, please update your mobile number in the profile settings before proceeding.<br /><br /><strong>Clients:</strong> If you encounter any issues or need assistance, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> for help.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user for assistance or, if you are unsure who your master user is, please contact our&nbsp;<a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'MFA.NotYourNumber.Cta.Text',
    value: 'Not your number?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'MFA.NotYourNumber.Title.Text',
    value: 'Not your number?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.MarketingPreference.Body1',
    value:
      '<p><strong>Keeping you informed</strong><br /><br />We will send you communications, including newsletters, insights, and updates on relevant topics.<br /><br /><a href="https://www.quiltercheviot.com/news-and-events/subscribe-to-a-newsletter/">Learn more about these communications</a><br /><br />We have organised our communication types as follows:</p>\n<ul>\n<li>Weekly Comment &ndash; Weekly</li>\n<li>Monthly Market Commentary &ndash; Monthly</li>\n<li>Quilter Cheviot Magazine &ndash; Quarterly</li>\n</ul>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.MarketingPreference.Body2',
    value:
      'More information on how we use your data is provided in the <a href="https://www.quiltercheviot.com/important-information/privacy-notice/">Quilter Cheviot Privacy Notice</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.MarketingPreference.Helptray.Cta.Body',
    value:
      '<p><strong>Why are we opting you into marketing communications?</strong><br />As part of our commitment to keeping you informed, we automatically opt you into some of our marketing communications. This ensures you receive the latest insights, updates, and newsletters that can help you stay informed about market trends, your investments, and other relevant topics.<br /><br /><strong>How can you manage your preferences?</strong><br />You have full control over the communications you receive from us. Here are the ways you can manage your preferences:</p>\n<ul>\n<li>Unsubscribe via Email: Each email we send includes an unsubscribe link at the bottom. Simply open this link to opt out.</li>\n<li>Update Preferences on Our Website: You can also update your marketing preferences at any time by visiting the <a href="https://www.quiltercheviot.com/news-and-events/subscribe-to-a-newsletter/">Quilter Cheviot Marketing Preferences Form</a>. Here, you can choose which newsletters and updates you wish to receive or opt out of all communications.</li>\n</ul>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.MarketingPreference.Helptray.Cta.Text',
    value: 'NEED HELP?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.MarketingPreference.Helptray.Cta.Title',
    value: 'Help with marketing preferences',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.MarketingPreference.Title',
    value: 'Marketing preferences',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Laptop.Body.Text',
    value:
      "We are pleased to welcome you to your new and improved web portal. <br /><br />We've listened to your feedback and have made some upgrades to your online experience.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Laptop.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/desktop-welcome-page-1.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Mobile.App.Body.Text',
    value:
      "We are pleased to welcome you to your new and improved Quilter Cheviot app. <br /><br />We've listened to your feedback and have made some upgrades to your online experience.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Mobile.App.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/welcome-page-app-1a.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Mobile.Web.Body.Text',
    value:
      "We are pleased to welcome you to your new and improved web portal. <br /><br />We've listened to your feedback and have made some upgrades to your online experience.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Mobile.Web.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/mobile-web-welcome-page-1.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Tablet.Body.Text',
    value:
      "We are pleased to welcome you to your new and improved web portal. <br /><br />We've listened to your feedback and have made some upgrades to your online experience.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Tablet.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/welcome-page-tablet-1a.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step1.Title.Text',
    value: 'Welcome to your new portal',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Laptop.Body.Text',
    value:
      'As well as getting up-to-date information for the assets you hold, you can now see the valuation and performance of your portfolios over time.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Laptop.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/desktop-welcome-page-2.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Mobile.App.Body.Text',
    value:
      'As well as getting up-to-date information for the assets you hold, you can now see the valuation and performance of your portfolios over time.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Mobile.App.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/welcome-page-app-2-image.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Mobile.Web.Body.Text',
    value:
      'As well as getting up-to-date information for the assets you hold, you can now see the valuation and performance of your portfolios over time.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Mobile.Web.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/mobile-web-welcome-page-2.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Tablet.Body.Text',
    value:
      'As well as getting up-to-date information for the assets you hold, you can now see the valuation and performance of your portfolios over time.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Tablet.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/welcome-page-tablet-2.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step2.Title.Text',
    value: 'Valuation and performance',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Laptop.Body.Text',
    value:
      'We are committed to ensuring that your information is kept safe and secure, and have enhanced the security surrounding your data.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Laptop.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/desktop-welcome-page-3.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Mobile.App.Body.Text',
    value:
      'We are committed to ensuring that your information is kept safe and secure, and have enhanced the security surrounding your data.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Mobile.App.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/welcome-page-app-3-image.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Mobile.Web.Body.Text',
    value:
      'We are committed to ensuring that your information is kept safe and secure, and have enhanced the security surrounding your data.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Mobile.Web.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/mobile-web-welcome-page-3.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Tablet.Body.Text',
    value:
      'We are committed to ensuring that your information is kept safe and secure, and have enhanced the security surrounding your data.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Tablet.Image.Link',
    value:
      'https://www.quiltercheviot.com/globalassets/external-assets-qc/welcome-page-tablet-3.png',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Migration.Step3.Title.Text',
    value: 'Your data security.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.AdviserPortal.HoldingPage.Body',
    value:
      'The Quilter Cheviot adviser portal is not yet supported in this app.<br /><br />...but we&rsquo;re working on it.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.AdviserPortal.HoldingPage.Title',
    value: "You're a little early",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.AdviserPortal.LinkText',
    value: 'Open adviser portal in browser',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.AppSettings.SecuritySettings.txt',
    value:
      "Configure your device's biometric settings to secure access to the app.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.AppStoreLink.Android.Href',
    value: 'https://play.google.com/store/apps/details?id=com.quilter.dig3',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.AppStoreLink.Ios.Href',
    value: 'https://apps.apple.com/gb/app/quilter-cheviot/id6451244008',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.ForcedUpdate.Body',
    value:
      "You need to update to the latest version. It won't take long, and will give you an even better experience.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.ForcedUpdate.Heading',
    value: 'We have made some important updates to our app',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.Login.Helptray.Body',
    value:
      '<strong>Clients:</strong> Simply use your My Quilter Cheviot details to log in. If you have not registered before or cannot remember your username, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> who will be able to set up your personalised access.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user to set up your access or remind you of your username for the My Quilter Cheviot portal. If you are unsure who your master user is, please contact our&nbsp;<a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.<br /><br /><strong>Forgotten password?</strong> If you cannot remember your password, you can use the "Forgot your password?" option once you have entered your username (which is typically your email address).<br /><br />If you need any further help, please view our <a href="https://www.quiltercheviot.com/myqc/support/" target="_blank" rel="noopener">support page</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.Login.Helptray.Title',
    value: 'Help with your login',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.Login.RegisterHelptray.Body',
    value:
      '<strong>Clients:</strong> Simply use your My Quilter Cheviot details to log in. If you have not registered before, please speak to your investment manager who will be able to set up your personalised access.<br /><br />You can find your investment manager\'s contact details <a href="https://www.quiltercheviot.com/contact-us/" target="_blank" rel="noopener">here</a>.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user to set up your access for the My Quilter Cheviot portal.<br /><br />If you are unsure who your master user is, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Mobile.Login.RegisterHelptray.Title',
    value: 'How To Register',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Body.Text',
    value:
      '<strong>The value of your investments and the income from them can fall and you may not recover what you invested.</strong>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Cta.Link',
    value: 'https://www.quiltercheviot.com/contact-us/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Cta.Text',
    value: 'Contact us',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link0.Link',
    value: 'https://www.quiltercheviot.com/contact-us/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link0.Text',
    value: 'Contact Quilter Cheviot',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link1.Link',
    value:
      'https://www.quiltercheviot.com/siteassets/documents/terms-and-conditions/qc-online-services-terms-and-conditions.pdf',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link1.Text',
    value: 'Online Services Terms &amp; Conditions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link2.Link',
    value: 'https://www.quiltercheviot.com/online-services-cookies-notice/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link2.Text',
    value: 'Online Services cookies notice',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link3.Link',
    value:
      'https://www.quiltercheviot.com/important-information/privacy-notice/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link3.Text',
    value: 'Privacy notice',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link4.Link',
    value:
      'https://www.quiltercheviot.com/important-information/corporate-and-regulatory-information/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link4.Text',
    value: 'Corporate and regulatory information',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link5.Link',
    value:
      'https://www.quiltercheviot.com/important-information/accessibility/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link5.Text',
    value: 'Accessibility',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link6.Link',
    value: 'https://www.quiltercheviot.com/myqc/support',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link6.Text',
    value: 'Frequently Asked Questions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link7.Link',
    value:
      'https://www.quiltercheviot.com/supporting-clients-with-additional-needs/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Link7.Text',
    value: 'Supporting clients with additional needs',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Social.Facebook.Link',
    value: 'https://www.facebook.com/quiltercheviot',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Social.LinkedIn.Link',
    value: 'https://www.linkedin.com/company/quilter-cheviot-ltd',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.Footer.Social.X.Link',
    value: 'https://twitter.com/QuilterCheviot',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Navigation.MarketingPreferences.Link',
    value:
      'https://www.quiltercheviot.com/news-and-events/subscribe-to-a-newsletter/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Confirmation.Body.Text',
    value: 'You can now use your new password to log in.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Confirmation.Title.Text',
    value: 'Your password has been updated',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Email.Confirmation.Body.Text',
    value:
      'We have sent a link to reset your password to the email address associated with this <strong>username</strong>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Email.Confirmation.Title.Text',
    value: 'Password reset email sent',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Helptray.Body',
    value:
      'If you have forgotten your password, you can reset it using the "Forgot your password" link.<br /><br />Before doing so, please ensure that you have entered the correct username.<br /><br /><strong>Clients:</strong> If you cannot remember your username, please contact your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a>.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you cannot remember your username, please contact your master user. If you are unsure who your master user is, please contact our&nbsp;<a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Helptray.Title',
    value: 'Recovering your password',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Phonefactor.Body.Text',
    value: 'Please enter the 6 digit code that we have just sent to:',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Phonefactor.Title.Text',
    value: 'SMS Code',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Request.Body.Text',
    value:
      "Double check that the <strong>username</strong> below is correct and we'll send you a reset email associated with that username.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Request.Title.Text',
    value: 'Forgotten your password?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Password.Reset.Set.Password.Title.Text',
    value: 'Enter new password',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Performance.Summary.CapitalReturn.Info.Text',
    value: 'The percentage of capital return during the selected timeframe.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Performance.Summary.IncomeReturn.Info.Text',
    value:
      'The percentage return by way of a dividend on shares or interest on bonds or cash.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Performance.Summary.PoorPerformance.Info.Text',
    value:
      'If you have any questions about the performance of your investments please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Performance.Summary.ShortTimeframeWarning.Info.Text',
    value:
      'You have selected a short performance window, and investing should generally be for the longer term. Assessments based on shorter timescales could be influenced by short-term volatility. If you have any questions, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Performance.Summary.TotalReturn.Info.Text',
    value:
      'The total percentage return combining the income and capital returns for the selected timeframe.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Details.ATBR.txt',
    value:
      'Your ability to financially withstand losing some or all of the value of your investments.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Details.Excluded.From.Total.Value.txt',
    value:
      'Is this portfolio excluded from the value of my total investments? (Only applicable where you hold multiple portfolios)',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Details.Objective.txt',
    value:
      'Whether you are aiming to achieve capital growth, income, or a combination of both from your investment.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Details.Responsible.investment.strategy.txt',
    value:
      'The extent to which you have integrated environmental, social and governance factors (ESG) into our investment decisions.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Details.Risk level.txt',
    value:
      'A description of how much risk your are willing to take in your investments.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Details.Service.level.txt',
    value: 'Your investment management service.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Details.Strategy.txt',
    value:
      'The investment strategy which balances your risk/reward profile taking into account your objective and risk profile.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Details.Valuation.Currency.txt',
    value:
      "The currency used to summarise values for this portfolio. Some of your holdings or accounts maybe in a different currency and will be converted into the portfolio's valuation currency.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Performance.LessThan3MonthsData.Alert.Text',
    value:
      'Please remember that these are long-term investments. As your portfolio is less than three months old, any gains or losses may not reflect longer-term trends.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.AccountList.Text',
    value: 'List of account linked to the portfolio',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.CapitalReturn.Info.Text',
    value: 'This represents the net capital return in your portfolios',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.CurrentValueTotal.Info.Text',
    value: 'This represents the current total value of all your portfolios',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.DateRange.Text',
    value: 'This shows the date range included within the selected timeframe.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.IncomeReturn.Info.Text',
    value:
      'This represents the net income return (e.g. Dividend, Interest etc) in your portfolios',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.NetCashIn.Info.Text',
    value:
      'The net position of the cash paid into or withdrawn from the accounts within your portfolio. This will reflect any transfers of cash between accounts within this period and any adviser fees paid.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.NetStockIn.Info.Text',
    value:
      'The net position of the stocks transferred into or out of accounts within your portfolio. This will reflect any transfers of stock between accounts within this portfolio.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.SeeAllEvent.Href',
    value:
      'https://www.quiltercheviot.com/news-and-events/events-and-webinars/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.SeeAllEvent.Label',
    value: 'See all events',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.SeeAllNews.Href',
    value: 'https://www.quiltercheviot.com/news-and-events/articles/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Summary.SeeAllNews.Label',
    value: 'See all articles',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Portfolio.Valuation.LessThan3MonthsData.Alert.Text',
    value:
      'Please remember that these are long-term investments. As your portfolio is less than three months old, any gains or losses may not reflect longer-term trends.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Reason.MaxCharacters.Text',
    value: 'You have exceeded the 200 character limit',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.CorrespondencePreference.Body',
    value:
      '<p>Your contact preferences are set to paperless by default so any documents (such as quarterly valuations and tax packs) you receive are available securely in your Documents section of your online account.<br /><br />You will be notified by email when a new document is available to view.<br /><br />If you prefer paper copies, you&rsquo;ll receive these documents by post in addition to having them available online. You can update your preferences at any time in My Profile under Contact Preferences.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.CorrespondencePreference.Helptray.Body',
    value:
      '<p>Your account is set to paperless by default during registration. This means documents like valuations and tax packs are stored securely in the Documents section of your online account.<br /><br />We&rsquo;ll email you whenever a new document is ready to be viewed.<br /><br />If you&rsquo;d like to receive paper copies as well, you can change your settings anytime in My Profile under Contact Preferences.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.CorrespondencePreference.Helptray.Cta.Text',
    value: 'Need help?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.CorrespondencePreference.Helptray.Title',
    value: 'Help with contact preferences',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.CorrespondencePreference.Title',
    value: 'Contact preferences',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Helptray.Body',
    value:
      '<p>Welcome to our online account registration process!</p>\n<p>You must agree to our Online Services Terms &amp; Conditions to proceed with your registration.</p>\n<p><strong>Clients:</strong> If you encounter any issues or need assistance during the registration process, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> for help.</p>\n<p><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user for assistance or, if you are unsure who your master user is, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.</p>\n<p>If you need any further help, please view our <a href="https://www.quiltercheviot.com/myqc/support/" target="_blank" rel="noopener">support page</a>.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Helptray.Title',
    value: 'Need help with registration?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.IDBlocked.Body',
    value:
      'For your security, your account has been temporarily blocked due to multiple incorrect entries of your Tax Identification Number or Portfolio Number. This measure helps ensure that the person registering the account is indeed who they claim to be and protects your data.<br /><br />To unblock your account and continue the registration process, please contact your investment manager for assistance.<br /><br />Thank you for your understanding and cooperation.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.IDBlocked.Title',
    value: 'Account Blocked Due to Multiple Incorrect Entries',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Link.Invalid.Body.Text',
    value:
      '<p>Hmmm, this link doesn&rsquo;t appear to be working. This could be for a number of reasons.</p>\n<p>If you are a client, please contact your&nbsp;<a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener"><span class="ql-und">investment management team</span></a>.</p>\n<p>If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user for assistance or, if you are unsure who your master user is, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Link.Invalid.Cta.Link',
    value:
      'https://www.quiltercheviot.com/about-us/our-investment-management-teams/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Link.Invalid.Cta.Text',
    value: 'Find my Investment Manager',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Link.Invalid.Title.Text',
    value: 'Sorry, this doesn&rsquo;t appear to be working',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Link.Used.Body.Text',
    value:
      'This registration link has already been used.<br /><br />Please return to the Login page and use the username and password you created previously.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Link.Used.Title.Text',
    value: 'Registration link used',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.MarketingPreferenceAndCorrespondencePreference.Body',
    value:
      'Your contact preferences are set to paperless by default so any documents (such as quarterly valuations and tax packs) you receive are available securely in your Documents section of your online account.<br /><br />You will be notified by email when a new document is available to view.<br /><br />If you prefer paper copies, you&rsquo;ll receive these documents by post in addition to having them available online. You can update your preferences at any time in My Profile under Contact Preferences.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.MarketingPreferenceAndCorrespondencePreference.Body1',
    value:
      '<p><strong>Keeping you informed</strong><br /><br />We will send you communications, including newsletters, insights, and updates on relevant topics.<br /><br /><a href="https://www.quiltercheviot.com/news-and-events/subscribe-to-a-newsletter/" target="_blank" rel="noopener">Learn more about these communications</a><br /><br />We have organised our communication types as follows:</p>\n<ul>\n<li>Weekly Comment &ndash; Weekly</li>\n<li>Monthly Market Commentary &ndash; Monthly</li>\n<li>Quilter Cheviot Magazine &ndash; Quarterly</li>\n</ul>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.MarketingPreferenceAndCorrespondencePreference.Body2',
    value:
      'More information on how we use your data is provided in the <a href="https://www.quiltercheviot.com/important-information/privacy-notice/" target="_blank" rel="noopener">Quilter Cheviot Privacy Notice</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.MarketingPreferenceAndCorrespondencePreference.Helptray.Cta.Body',
    value:
      '<p><strong>Contact Preferences:</strong><br /><br />Your contact preferences are set to paperless by default so any documents (such as quarterly valuations and tax packs) you receive are available securely in your Documents section of your online account.<br /><br />You will be notified by email when a new document is available to view.<br /><br />If you prefer paper copies, you&rsquo;ll receive these documents by post in addition to having them available online. You can update your preferences at any time in My Profile under Contact Preferences.<br /><br /><strong>Marketing Preferences:</strong><br /><br />You&rsquo;ll be opted into receiving the following marketing content as part of signing up for your online account:</p>\n<ul>\n<li>Weekly Comment</li>\n<li>Monthly Market Commentary</li>\n<li>Quilter Cheviot Magazine Quarterly</li>\n</ul>\n<br />You can easily opt out from any of these by deselecting the ones you don&rsquo;t want to receive during the sign-up process. You can also update your preferences at any time through our marketing preference form or by clicking the &ldquo;unsubscribe&rdquo; link in any of our emails.<br /><br />\n<p><strong>Why are we opting you into marketing communications?</strong><br />As part of our commitment to keeping you informed, we automatically opt you into some of our marketing communications. This ensures you receive the latest insights, updates, and newsletters that can help you stay informed about market trends, your investments, and other relevant topics.<br /><br /><strong>How can you manage your preferences?</strong><br />You have full control over the communications you receive from us. Here are the ways you can manage your preferences:</p>\n<ul>\n<li>Unsubscribe via email: Each email we send includes an unsubscribe link at the bottom. Simply open this link to opt out.</li>\n<li>Update preferences on our website: You can also update your marketing preferences at any time by visiting the <a href="https://www.quiltercheviot.com/news-and-events/subscribe-to-a-newsletter/">Quilter Cheviot newsletter subscription form</a>. Here, you can choose which newsletters and updates you wish to receive or opt out of all communications.</li>\n</ul>\n<br />If you have any questions or need further assistance, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.MarketingPreferenceAndCorrespondencePreference.Helptray.Cta.Text',
    value: 'NEED HELP?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.MarketingPreferenceAndCorrespondencePreference.Helptray.Cta.Title',
    value: 'Help with contact and marketing preferences',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.MarketingPreferenceAndCorrespondencePreference.Title',
    value: 'Contact and marketing preferences',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Multifactor.Body.Text',
    value: 'Please enter the 6 digit code that we have just sent to:',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Multifactor.Cta.Text',
    value: 'Continue',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Multifactor.Title.Text',
    value: 'SMS Code',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Set.Confirm.Password.Input.Text',
    value: 'Please confirm your new password',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Set.Password.Input.Text',
    value:
      'Please create a secure password between <strong>14</strong> and <strong>64</strong> characters',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Set.Password.Tip.Text',
    value:
      '<strong>Tip:</strong>&nbsp;Try using 3 random words as your password',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Set.Password.Title.Text',
    value: 'Password',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Set.Username.Body.Text',
    value:
      'Please create a unique username. We have currently defaulted this to your email address but you can change this if you wish.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Set.Username.Title.Text',
    value: 'Username',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyPortfolioCode.Body',
    value: 'Please enter your Portfolio Number',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyPortfolioCode.Helptray.Body',
    value:
      'To validate your identity, please enter one of your portfolio numbers. You can find this number in the documents we have sent you. We will compare this with the information we have on record to confirm your identity. If you need assistance locating your portfolio number, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyPortfolioCode.Helptray.Cta.Text',
    value: 'NEED HELP?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyPortfolioCode.Helptray.Title',
    value: 'Help with Entering Your Portfolio Number',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyPortfolioCode.Title',
    value: 'Additional information',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyTIN.Body',
    value:
      'Please enter your Tax Identification Number (National Insurance Number, Irish Personal Public Service (PPS) Number or other)',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyTIN.Helptray.Body',
    value:
      'To validate your identity, please enter your Tax Identification Number (TIN). <br /><br />This could be your <br />\n<ul>\n<li>National Insurance Number (NINO)</li>\n<li>Irish Personal Public Service Number (PPS)</li>\n<li>or any other international tax identifier.</li>\n</ul>\nWe will compare this with the information we have on record for you to confirm your identity. <br /><br />Please contact your investment manager if you require any further help with this.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyTIN.Helptray.Cta.Text',
    value: 'NEED HELP?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyTIN.Helptray.Title',
    value: 'Help with Entering Your Tax Identification Number',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.VerifyTIN.Title',
    value: 'Additional information',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Welcome.Body.Text',
    value:
      '<p>We&rsquo;re pleased to have you here. Creating your account is straightforward. Here&rsquo;s what you can expect from the registration process:</p>\n<ol>\n<li><strong>Agree to our Online Services Terms &amp; Conditions</strong>: Review and accept our terms to proceed.</li>\n<li><strong>Create your credentials</strong>: Enter your chosen username and password. Your username can be an email address, but it doesn&rsquo;t have to be. You&rsquo;ll find hints on the password entry screen to help you decide on a secure password. Once you&rsquo;ve created your credentials, you&rsquo;ll receive an email confirming your account registration. You can then log in with these credentials to continue the registration process at any time.</li>\n<li><strong>Enter one-time code</strong>: For security purposes, you&rsquo;ll need to enter a one-time code sent to your mobile number.</li>\n<li><strong>Identity verification</strong>: If we have your tax reference number on record, you will be prompted to provide it. If not, you will need to provide your portfolio number to pass the identity check and access your account.</li>\n<li><strong>Contact preferences</strong>: Review your contact and/or marketing preferences to complete the registration.</li>\n</ol>\n<p>Once you&rsquo;ve created your credentials, you can take a break and come back anytime. Simply log in with your username, password and a one-time code sent to your mobile to continue where you left off.</p>\n<p>Let&rsquo;s get started!</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Welcome.Cta.Text',
    value: 'CONTINUE - I agree to the terms',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Welcome.Terms.Link',
    value:
      'https://www.quiltercheviot.com/siteassets/documents/terms-and-conditions/qc-online-services-terms-and-conditions.pdf',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Welcome.Terms.Text',
    value: 'View Online Services Terms &amp; Conditions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Registration.Welcome.Title.Text',
    value: 'Welcome to My Quilter Cheviot',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Add.Button.Label',
    value: 'Add a passkey',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Add.Button.Pressed.Label',
    value: 'Adding passkey',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Add.NotSupported.Body',
    value:
      'You cannot create a new passkey on this device. To continue, use a passkey that was created on another supported device, or try creating one on a different device.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Add.NotSupported.Title',
    value: 'This device does not support passkeys',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Add.Success.Message',
    value: 'Passkey added successfully',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.AddingPage.Body',
    value: "We're creating your passkey. This may take a few moments.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.AddingPage.Failed.Back.Button.Label',
    value: 'Back to Security settings',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.AddingPage.Failed.Body',
    value:
      'We could not create your passkey. Please try again, or return to Security settings. If the problem continues, contact us for help.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.AddingPage.Failed.RetryPasskey.Button.Label',
    value: 'Try again',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.AddingPage.Success.Body',
    value: 'You have successfully set-up a new passkey.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.AddingPage.Success.Title',
    value: 'Success',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.AddingPage.Title',
    value: 'Creating your passkey',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Delete.Confirm.Body',
    value:
      'This passkey will be removed from your My Quilter Cheviot account. You may also need to remove it from your device, browser, or password manager.\n\nOnce deleted, this passkey cannot be recovered. You can add a new passkey at any time.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Delete.Confirm.Button.Label',
    value: 'DELETE PASSKEY',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Delete.Confirm.Title',
    value: 'Delete this passkey?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Delete.Failed.Message',
    value:
      'We could not delete your passkey. Please try again. If the problem continues, contact us for help.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Delete.Success.Message',
    value: 'Passkey deleted successfully.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.DeletingPage.Body',
    value:
      "Please wait while we delete your passkey. You'll be returned to My Quilter Cheviot once it's complete.",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.DeletingPage.Failed.Title',
    value: "We couldn't delete your passkey",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.DeletingPage.Success.Body',
    value: 'Passkey deleted successfully.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.DeletingPage.Success.Title',
    value: 'Success',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.DeletingPage.Title',
    value: 'Deleting your passkey',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.List.Body',
    value:
      'Passkeys let you sign in securely without a password using the verification method set up on your device, such as your fingerprint, face, PIN, or pattern.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.List.Title',
    value: 'Passkeys',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Rename.Body',
    value:
      'Enter a new name for your passkey. Choose a name that helps you recognise it later.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Rename.EmptyError.Message',
    value: 'Please enter a passkey name.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Rename.Fail.Message',
    value: 'We could not rename your passkey. Please try again.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Rename.Success.Message',
    value: 'Passkey renamed successfully.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.Rename.Title',
    value: 'Rename passkey',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'SecuritySettings.Passkeys.UnspecifiedName',
    value: 'Unspecified Passkey',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.AddPasskey.SMSVerification.Helptray.Cta.Text',
    value: 'Not correct number?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.AddPasskey.SMSVerification.Helptray.Text',
    value:
      'If the mobile number shown on the screen is not correct, please update your mobile number in the profile settings before proceeding.<br /><br /><strong>Clients:</strong> If you encounter any issues or need assistance, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> for help.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user for assistance or, if you are unsure who your master user is, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.AddPasskey.SMSVerification.Helptray.Title',
    value: 'Not correct number?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.AddPasskey.SMSVerification.Text',
    value:
      'For your security we have sent you a verification code to your <strong>mobile number</strong>:',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.AddPasskey.SMSVerification.Title',
    value: "Checking it's you",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.EmailVerification.Helptray.Cta.Text',
    value: 'Not correct?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.EmailVerification.Helptray.Text',
    value:
      '<p><strong>Clients</strong>: If the email address shown on the screen is not correct, please update your email address in the profile settings before proceeding. If you encounter any issues or need assistance, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> for help.</p>\n<p><strong>Financial Advisers or Corporate Users</strong>: If you are a financial adviser or an employee of an advice or corporate firm, and the email address shown on screen is not correct, please contact your master user to update it. If you are unsure who your master user is, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.EmailVerification.Helptray.Title',
    value: 'Not correct?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.EmailVerification.Subtitle',
    value:
      'For your security we have sent you a verification code to your <strong>email address:</strong>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.EmailVerification.Title',
    value: "Checking it's you",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.ErrorScreen.Text',
    value:
      'Sorry we were unable to update your mobile number. We are redirecting you back to the app...',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.ErrorScreen.Title',
    value: 'Something went wrong',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.NewNumberScreen.Alert',
    value:
      'This number will be used for two-factor authentication to enhance the security of your account.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.NewNumberScreen.Subtitle',
    value: 'Please enter your new <strong>mobile number:</strong>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.NewNumberScreen.Title',
    value: 'Edit mobile number',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.Success.Subtitle',
    value: 'Your new number has been successfully changed!',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.Success.Title',
    value: 'Success',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.VerifyNewMobile.Helptray.Cta.Text',
    value: 'Not correct?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.VerifyNewMobile.Helptray.Text',
    value:
      'If the mobile number shown on the screen is not correct, please update your mobile number in the profile settings before proceeding.<br /><br /><strong>Clients:</strong> If you encounter any issues or need assistance, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> for help.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user for assistance or, if you are unsure who your master user is, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.VerifyNewMobile.Helptray.Title',
    value: 'Not correct?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.VerifyNewMobile.Text',
    value:
      'Please enter the one-time code sent to your <strong>new mobile number</strong> to verify it.<br /><br />Your new number will <strong>not be saved</strong> until it has been successfully verified.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.ChangePhoneNumber.VerifyNewMobile.Title',
    value: 'Verify new number',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.ErrorScreen.Text',
    value:
      'Sorry we were unable to update your email address. We are redirecting you back to the app...',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.ErrorScreen.Title',
    value: 'Something went wrong',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.NewEmailScreen.Subtitle',
    value: 'Please enter your new email address.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.NewEmailScreen.Title',
    value: 'Edit email address',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.SMSVerification.Helptray.Cta.Text',
    value: 'Not correct number?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.SMSVerification.Helptray.Text',
    value:
      'If the mobile number shown on the screen is not correct, please update your mobile number in the profile settings before proceeding.<br /><br />If you encounter any issues or need assistance, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> for help.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.SMSVerification.Helptray.Title',
    value: 'Not correct?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.SMSVerification.Subtitle',
    value:
      'For your security we have sent you a verification code to your <strong>mobile number</strong>:',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.SMSVerification.Title',
    value: "Checking it's you",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.Success.Text',
    value: 'Your new email address has been successfully changed!',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.Success.Title',
    value: 'Success',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.VerifyNewEmail.Helptray.Cta.Text',
    value: 'Email not correct?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.VerifyNewEmail.Helptray.Text',
    value:
      'It looks like the <strong>email address</strong> you entered is not correct. Please choose &ldquo;Cancel&rdquo; and start the update email address process again.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.VerifyNewEmail.Helptray.Title',
    value: 'Email not correct?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.VerifyNewEmail.Text',
    value:
      'Please enter the one-time code sent to your <strong>new email address</strong> to verify it.<br /><br />Your new email will <strong>not be saved</strong> until it has been successfully verified.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdateEmail.VerifyNewEmail.Title',
    value: 'Verify new email',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.ErrorScreen.Subtitle',
    value:
      'Sorry we were unable to update your password. We are redirecting you back to the app...',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.ErrorScreen.Title',
    value: 'Something went wrong',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.Mobile.Success.ToastMessage',
    value:
      'Your password has been changed and you&rsquo;ve been logged out. Log in with your new password to continue. If you used biometrics before, they&rsquo;ll be turned back on after you log in.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SMSVerification.Helptray.Cta.Text',
    value: 'Not correct number?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SMSVerification.Helptray.Text',
    value:
      'If the mobile number shown on the screen is not correct, please update your mobile number in the profile settings before proceeding.<br /><br /><strong>Clients:</strong> If you encounter any issues or need assistance, please speak to your <a href="https://www.quiltercheviot.com/about-us/our-investment-management-teams/" target="_blank" rel="noopener">investment management team</a> for help.<br /><br /><strong>Financial Advisers or Corporate Users:</strong> If you are a financial adviser or an employee of an advice or corporate firm, please contact your master user for assistance or, if you are unsure who your master user is, please contact our <a href="mailto:qcadvisersupport@quiltercheviot.com">support team</a>.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SMSVerification.Helptray.Title',
    value: 'Not correct number?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SMSVerification.Text',
    value:
      'For your security we have sent you a verification code to your <strong>mobile number</strong>:',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SMSVerification.Title',
    value: "Checking it's you",
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SetPassword.Helptray.Cta.Text',
    value: 'NEED HELP?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SetPassword.Helptray.Text',
    value:
      'To set a new password, ensure it is between 14 and 64 characters long and different from your username. After entering your new password, re-enter it to confirm both entries match. Avoid easily guessable information like your name or birthdate. If you need further assistance, please contact our support team.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SetPassword.Helptray.Title',
    value: 'NEED HELP?',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.SetPassword.Title',
    value: 'Change Password',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.Success.Subtitle',
    value: 'You have successfully updated your Quilter Cheviot password',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.Success.Title',
    value: 'Success',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Stepup.UpdatePassword.Web.Success.ToastMessage',
    value:
      'Your password has been changed. For security, you&rsquo;ve been logged out. Please log in again using your new password.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'TermsOfUse.Full.HTML',
    value:
      '<h2>1. Agreement</h2>\n<p><strong>1.</strong> These terms and conditions are personal to you and non-transferable. They outline the legal basis of your agreement with us for accessing and using our <strong>online services</strong>. For <strong>clients</strong>, they supplement both our <strong>client terms and conditions </strong>and our <strong>website terms</strong>. For <strong>advisers</strong>, they supplement the <strong>introducer terms of business </strong>and our <strong>website terms</strong>. Our <strong>client terms and conditions </strong>or <strong>introducer terms of business </strong>(together the &ldquo;<strong>standard terms</strong>&rdquo;) have already been agreed to when completing an application for one or more of our services, or our Introducer Registration Form (as applicable).</p>\n<p><strong>1.1.</strong> Sole owner accounts</p>\n<p><strong>1.1.1. </strong>Where you are the sole <strong>account </strong>holder, you will be the <strong>user </strong>of the <strong>online services</strong>.</p>\n<p><strong>1.1.2.</strong> These terms and conditions apply to all of your <strong>accounts</strong>. If you open a new <strong>account</strong> in the future, then&nbsp;these terms and conditions will apply to such new <strong>account</strong>.</p>\n<p><strong>1.2.</strong> Joint accounts, trustees and companies</p>\n<p><strong>1.2.1.</strong> Each holder of a joint <strong>account</strong> who wishes to access and use the <strong>online services</strong> will need to separately&nbsp;register as a <strong>user</strong>. Once registered, each joint <strong>account</strong> holder will be able to independently access the&nbsp;<strong>online services</strong> to view the <strong>account</strong> details.</p>\n<p><strong>1.2.2.</strong> These terms and conditions apply to all <strong>accounts</strong> which you own jointly.</p>\n<p><strong>1.2.3.</strong> If you jointly open a new <strong>account </strong>in the future, then these terms and conditions will apply to such new&nbsp;<strong>account</strong>.</p>\n<p><strong>1.2.4.</strong> Each individual account operator of a trust, charity or corporate account who wishes to access and use the online services must register as a user. Once registered, each such account operator will be able to independently access the online services to view the relevant account details.</p>\n<p><strong>1.3.</strong> By accepting these terms and conditions and registering as a <strong>user</strong> you are agreeing to log into the <strong>online&nbsp;services</strong> at least once every 13 months. We reserve the right to monitor the frequency with which you&nbsp;access our <strong>online services</strong>.</p>\n<h2>2. Definitions</h2>\n<p><strong>2.1.</strong> We, us or our means, as applicable, Quilter Cheviot Limited which is a private limited company registered in England and Wales with number 01923571, and whose registered office is at Senator House, 85 Queen&nbsp;Victoria Street, London EC4V 4AB or Quilter Cheviot Europe Limited which is a private limited company&nbsp;registered in Ireland with number 643307, and whose registered address is at Hambleden House, 19-26&nbsp;Lower Pembroke Street, Dublin D02 WV96 or Quilter Cheviot International Limited which is a private&nbsp;limited company registered in Jersey with number 128676, registered office at 3rd Floor, Windward House,&nbsp;La Route de la Liberation, St Helier, JE1 1QJ, Jersey.</p>\n<p>You or your means the <strong>account operator </strong>who has registered as a <strong>user</strong>.</p>\n<p><strong>2.2.</strong> Any words given a special meaning in these terms and conditions are defined below and appear in bold type throughout.</p>\n<p><strong>2.3.</strong> If the meaning of a word is explained in the singular below then it includes the plural of that word and vice&nbsp;versa and the masculine or the feminine gender includes all genders.</p>\n<p>&ldquo;<strong>Account</strong>&rdquo;: The <strong>client&rsquo;s </strong>Quilter Cheviot account(s)</p>\n<p>&ldquo;<strong>Account operator</strong>&rdquo;: The <strong>client</strong>, <strong>adviser</strong> or other individual with due authority over an <strong>account</strong></p>\n<p>&ldquo;<strong>Adviser</strong>&rdquo;: A financial adviser or an employee of a financial advice firm registered with us. Certain advisers may be nominated as <strong>master users</strong> with enhanced access rights</p>\n<p>&ldquo;<strong>App</strong>&rdquo;: The Quilter Cheviot mobile application which is accessible by the <strong>user</strong> from their mobile device</p>\n<p>&ldquo;<strong>Applicable data protection laws</strong>&rdquo;: Includes the UK GDPR, EU GDPR, Data Protection Act 2018 (UK), Irish Data Protection Act 2018, Data Protection (Jersey) Law 2018, and any other applicable legislation governing the processing of <strong>personal data</strong> in the jurisdictions in which we operate</p>\n<p>&ldquo;<strong>Client</strong>&rdquo;: The person, trust or entity with an <strong>account </strong>and in receipt of a service from us</p>\n<p>&ldquo;<strong>Client terms and conditions</strong>&rdquo;: Our standard client terms and conditions which govern the investment management and any other services we provide to <strong>clients</strong></p>\n<p>&ldquo;<strong>Cookies policy</strong>&rdquo;: The Quilter Cheviot cookies policy which is available on our <strong>website</strong> at <a href="https://www.quiltercheviot.com/important-information/cookies-notice/" target="_blank" rel="noopener">www.quiltercheviot.com/important-information/cookies-notice/</a></p>\n<p>&ldquo;<strong>Introducer terms of business</strong>&rdquo;: Our standard introducer terms of business which govern our relationship&nbsp;with <strong>advisers</strong> and financial advice firms registered with us</p>\n<p>&ldquo;<strong>Login details</strong>&rdquo;: The unique username and password used by the <strong>user </strong>to access the <strong>online services</strong></p>\n<p>&ldquo;<strong>MyQuilterCheviot</strong>&rdquo;: The online portal accessible via our <strong>website</strong></p>\n<p>&ldquo;<strong>Master user</strong>&rdquo;<strong>:&nbsp;</strong>A <strong>user</strong> who is an <strong>account operator</strong> with authority over one or more <strong>accounts</strong> and who has enhanced access rights to view multiple <strong>accounts</strong> and manage access rights for other <strong>users</strong>, in each case subject to our approval and oversight</p>\n<p>&ldquo;<strong>Online services</strong>&rdquo;: <strong>MyQuilterCheviot </strong>and the <strong>App</strong></p>\n<p>&ldquo;<strong>Paperless delivery</strong>&rdquo;: The electronic provision of <strong>reports </strong>via the <strong>online services</strong></p>\n<p>&ldquo;<strong>Personal data</strong>&rdquo;: Any information relating to an identified or identifiable natural person that is processed&nbsp;by us; an identifiable natural person is one who can be identified, directly or indirectly, in particular by&nbsp;reference to an identifier such as a name, identification number, location data, an online identifier or to one&nbsp;or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity&nbsp;of that natural person</p>\n<p>&ldquo;<strong>Privacy notice</strong>&rdquo;: The Quilter Cheviot privacy notice which is available on our <strong>website </strong>at <a href="https://www.quiltercheviot.com/important-information/privacy-notice/" target="_blank" rel="noopener"><strong>www.quiltercheviot.com/important-information/privacy-notice/</strong></a></p>\n<p>&ldquo;<strong>Report</strong>&rdquo;: A quarterly valuation, statement, tax reporting pack or other document relating to an <strong>account</strong>&nbsp;and made available by us via the <strong>online services</strong> from time to time</p>\n<p>&ldquo;<strong>Security details</strong>&rdquo;: The <strong>account operator&rsquo;s</strong> unique security details required to complete the registration&nbsp;process or the <strong>user&rsquo;s login details</strong> once registered</p>\n<p>&ldquo;<strong>User</strong>&rdquo;: The <strong>account operator </strong>who has successfully registered to use the <strong>online services</strong></p>\n<p>&ldquo;<strong>Website</strong>&rdquo;: The Quilter Cheviot website at the domain <a href="https://www.quiltercheviot.com/" target="_blank" rel="noopener"><strong>www.quiltercheviot.com</strong></a> and the pages within it including or such other domain as notified to you from time to time</p>\n<p>&ldquo;<strong>Website terms</strong>&rdquo;: The terms and conditions which apply to the use of, and access to, our <strong>website </strong>and which are available on our <strong>website </strong>at <a href="https://www.quiltercheviot.com/important-information/website-terms/" target="_blank" rel="noopener"><strong>www.quiltercheviot.com/important-information/website-terms</strong></a></p>\n<h2>3. Scope of this agreement</h2>\n<p><strong>3.1.</strong> The <strong>standard terms</strong> detail the circumstances in which we may communicate in relation to an <strong>account</strong> and provide access to our <strong>online services</strong>. These terms and conditions apply to your use of the <strong>online services</strong> as a <strong>user</strong>. By accepting these terms and conditions, you confirm that you are acting as an <strong>account operator</strong> with authority over the relevant <strong>account</strong> and consent to us communicating with you electronically in accordance with our regulatory obligations.</p>\n<p><strong>3.2.</strong> If there is any conflict between these terms and conditions and the <strong>standard terms</strong> applicable to you, the <strong>standard terms</strong> shall prevail, except to the extent that the conflict relates solely to the technical operation of, or access to, the <strong>online services</strong>, in which case these terms and conditions shall apply and always to the extent permitted by applicable law and regulation.</p>\n<p><strong>3.3.</strong> If any of these terms and conditions are or become void or unenforceable, that will not affect the validity or enforceability of any other term of these terms and conditions.</p>\n<p><strong>3.4.</strong> We may make changes to and alter the facilities and services available via the <strong>online services</strong> at any time.&nbsp;We will notify you of any material changes the next time you log into the <strong>online services</strong>.</p>\n<p><strong>3.5.</strong> You must not reveal or share your <strong>security details</strong> with anyone else, including third-party companies,&nbsp;and must take reasonable steps to keep them secure at all times. You must also take reasonable steps to&nbsp;prevent any unauthorised use of your <strong>security details</strong>, including use by others. You will be responsible for&nbsp;any costs we incur in putting right any action carried out on any of the <strong>accounts</strong> and for any losses or costs&nbsp;we incur or for any claims against us caused by any such unauthorised use of our <strong>online services</strong>.</p>\n<p><strong>3.6.</strong> We do not offer any investment advice or personal recommendations via our <strong>online services</strong> and no&nbsp;information contained within the <strong>online services</strong> is or should be construed as such.</p>\n<p><strong>3.7.</strong> Where you are an <strong>adviser</strong> or <strong>master user</strong>, you acknowledge and agree that your access to <strong>client account</strong> information is limited to those <strong>clients</strong> who have provided appropriate authority or where such access is otherwise permitted or necessary under the <strong>standard terms</strong>.</p>\n<h2>4. Registration</h2>\n<p><strong>4.1.&nbsp;</strong>Our <strong>online services</strong> are only available to registered <strong>users</strong> once you have accepted these terms and conditions. The registration process can only be completed once we have been provided with your unique <strong>security details</strong> so we can conduct the essential verification required to protect you and the relevant <strong>account</strong> against a fraudulent registration.</p>\n<p><strong>4.2. </strong>Each <strong>account operator</strong> must register using their own <strong>security details</strong> and, if there is more than one <strong>account operator</strong> for an <strong>account</strong>, each <strong>account operator</strong> will be required to register using their own <strong>security details</strong>.</p>\n<p><strong>4.3.&nbsp;</strong>You must notify us if your email address, mobile telephone number or any other information provided to us changes in the future so that we can update our records and maintain the security of our communications and the <strong>online services</strong>.</p>\n<h2>5. Master user access and responsibilities</h2>\n<p><strong>5.1.</strong> This section applies if you are a <strong>master user</strong>. We reserve the right to approve, deny or revoke <strong>master user</strong> status at our discretion.</p>\n<p><strong>5.2.</strong> We will grant access to nominated <strong>users</strong> within the <strong>master user&rsquo;s</strong> organisation or account structure only upon instruction from the <strong>master user</strong> and subject to each <strong>user&rsquo;s</strong> acceptance of these terms and conditions. The <strong>master user</strong> must ensure that all <strong>users</strong> for whose access to the online services they are responsible comply with these terms and conditions and applicable laws.</p>\n<p><strong>5.3.</strong> <strong>Master users</strong> must ensure that all access to and processing of <strong>personal data</strong> via the <strong>online services</strong> is carried out in compliance with <strong>applicable data protection laws</strong>, including but not limited to, the obligations&nbsp;listed in clauses 15.3, 15.5 and 15.6 below.</p>\n<p><strong>5.4.</strong> <strong>Master users</strong> must cooperate with us in responding to any data subject access requests, complaints, or&nbsp;regulatory investigations relating to your use of the <strong>online services</strong>.</p>\n<p><strong>5.5.&nbsp;</strong>If a <strong>master user</strong> or any individual <strong>user</strong>&nbsp;whose access to the <strong>online services</strong> is managed by such <strong>master user</strong>&nbsp;is no longer entitled to access the <strong>online services</strong> (e.g. due to change of employment, resignation, or a change in role, office or authority), the <strong>master user</strong> must immediately notify Quilter Cheviot and revoke access. Failure to do so may result in suspension of access for the <strong>user</strong> or the entire adviser firm or client organisation as a whole.</p>\n<h2>6. Accessing the online services</h2>\n<p><strong>6.1. </strong>When using the <strong>online services </strong>you must follow any procedures or instructions we give you.</p>\n<p><strong>6.2.</strong> If you are no longer an <strong>account operator </strong>or otherwise cease to be authorised to access our <strong>online services</strong>, you must not access <strong>MyQuilterCheviot </strong>or the <strong>App</strong>. We will also take measures to ensure access is restricted.</p>\n<p><strong>6.3.</strong> To use our <strong>online services </strong>you will need a mobile device, particular device specifications and internet connections with necessary hardware and particular software, which may change in the future. If a change in specification or internet connections results in your equipment becoming incompatible with the <strong>online </strong><strong>services</strong>, you will be responsible for replacing or modifying your equipment so that you can continue using them.</p>\n<p><strong>6.4.</strong> If you want to access the <strong>online services </strong>using the <strong>App </strong>you will need to download the <strong>App </strong>to your mobile device and you will need to log in (following initial registration described in clause 4.1) to be able to use it.</p>\n<p><strong>6.5.</strong> You will be responsible for any telephone (including mobile carrier), internet service provider and other charges you incur as a result of obtaining access to our <strong>online services</strong>. You must not interfere with the proper working of our&nbsp;<strong>online services </strong>and, in particular, you must not attempt to circumvent security, tamper with, hack into or otherwise disrupt the <strong>online services </strong>or any computer system, server, router or any other internet-connected device.</p>\n<p><strong>6.6.</strong> You agree not to use the <strong>online services </strong>for any unlawful purpose or in any way that could damage, disable, overburden, or impair the <strong>website</strong>. This includes, but is not limited to, attempting to gain unauthorized access to systems, sharing <strong>security details</strong>, data scraping, or embedding hard-coded credentials in software or scripts. You must not misuse our <strong>online services </strong>by knowingly introducing viruses, trojans, worms, logic bombs, or other material that is malicious or technologically harmful. You must not attack our <strong>online services </strong>via a denial-of-service attack or a distributed denial-of-service attack. By breaching this provision, you would commit a criminal offense under the Computer Misuse Act 1990. We will report any such breach to the relevant law enforcement authorities and we will cooperate with those authorities by disclosing your identity to them. In the event of such a breach, your right to use our <strong>online services </strong>will cease immediately. Any such activities are considered a violation of these terms and conditions.</p>\n<p><strong>6.7.</strong> It may be necessary for us to suspend or withdraw access by disabling your <strong>security details </strong>for reasons such as security concerns or suspected unauthorised use. This includes, but is not limited to, the sharing of <strong>security details</strong>, data scraping and the use of hard-coded access methods, or any other misuse of our <strong>online services</strong>.</p>\n<p><strong>6.8.</strong> We will not be responsible for any loss or damage you suffer as a result of using our <strong>online services </strong>unless that loss or damage was foreseeable and caused by our failure to comply with these terms and conditions or our negligence, fraud or wilful default. We will not be liable for any loss or damage that is not foreseeable or which is the result of, or caused by:</p>\n<p><strong>a.</strong> unauthorised use of your <strong>security details</strong> or unauthorised access to our <strong>online services</strong> (including access to any confidential information accessible via the <strong>online services</strong>) resulting from such unauthorised use of your <strong>security details</strong> or from your failure to follow any instructions or guidance we may provide about keeping your <strong>account</strong> secure;<br /><strong>b.</strong> non-transmission or garbling of communications between us;<br /><strong>c.</strong> any disruption to our <strong>online services </strong>or of the internet or communication network that is used to provide access to our <strong>online services</strong>;<br /><strong>d.</strong> any malfunction of your equipment;<br /><strong>e.</strong> any loss of data;<br /><strong>f.</strong> routing difficulties;<br /><strong>g.</strong> operation of your software or hardware;<br /><strong>h.</strong> the effects of any virus, malicious computer code or any other anomaly or technical failure; or<br /><strong>i.</strong> damage to your computer or systems.</p>\n<p><strong>6.9.</strong> We accept no responsibility for any information contained in any website other than those forming part of our <strong>online services </strong>which is accessed via a link from our <strong>online services</strong>. The content, accuracy and opinions expressed in such websites are not checked, analysed, monitored or endorsed by us.</p>\n<p><strong>6.10.</strong> Whilst reasonable care has been taken to ensure that the information contained within our <strong>online services </strong>is accurate and up to date, no warranty is given as to the accuracy or completeness of any information provided to us by a third party and no liability is accepted for any errors or omissions in such information.</p>\n<p><strong>6.10.1.</strong> You understand that we cannot and do not guarantee or warrant that any content of our <strong>online services </strong>will be free from infection, viruses and/or other malicious computer code including those that have contaminating or destructive purposes. You are responsible for implementing and maintaining sufficient procedures and virus checks (including anti-virus and other security software) to satisfy your particular requirements for the safety and reliability of data input and output.</p>\n<p><strong>6.10.2.</strong> We give no guarantees as the speed, &lsquo;look and feel&rsquo; or availability of our <strong>online services</strong>.</p>\n<p><strong>6.10.3. </strong>We will not be liable for any failure of our <strong>online services </strong>to provide information related to your <strong>account(s) </strong>or failure to provide update information on a &lsquo;real time basis&rsquo;.</p>\n<p><strong>6.11.</strong> You are responsible for complying with all local laws of the country from which you access our <strong>online services</strong>.</p>\n<p><strong>6.12.</strong> Notwithstanding any other term of these terms and conditions, we do not exclude or limit in any way our liability to you where it would be unlawful to do so. This includes liability for death or personal injury caused by our negligence or the negligence of our employees, agents or subcontractors and for fraud or fraudulent misrepresentation.</p>\n<p><strong>6.13.</strong> If we supply defective digital content to you which damages a device or digital content belonging to you and this is caused by our failure to use reasonable care and skill, we will, at our sole discretion, either repair the damage within a reasonable time and without significant inconvenience to you and bear any necessary costs incurred in repairing the damage, or pay you compensation. However, we will not be liable for damage that you could have avoided by following our advice to apply an update offered to you free of charge or for damage that was caused by you failing to correctly follow installation instructions or to have in place the minimum system requirements advised by us.</p>\n<h2>7. Availability of the online services</h2>\n<p><strong>7.1.</strong> We aim to have the <strong>online services </strong>available at all times however we are not obliged to provide them at all times and may withdraw, suspend or restrict service temporarily without prior notice and at our discretion. There may also be times when we need to shut them down for maintenance, upgrades, updates or to address an actual or suspected security risk.</p>\n<p><strong>7.2.</strong> If we are unable to offer the <strong>online services </strong>we will aim to restore your access to them as quickly and efficiently as is reasonably possible. However, we will not be liable for any losses or damages you or third parties have suffered if the <strong>online services </strong>are unavailable at any time, for whatever reason.</p>\n<p><strong>7.3.</strong> Wherever reasonably possible, we will give you advance notice of our intention to withdraw, suspend or restrict your access to the <strong>online services</strong>. Where that is not possible and for the duration of any such withdrawal, suspension or restriction, you will (subject to applicable law and regulation) still be able to access your <strong>account </strong>information by contacting your investment manager.</p>\n<p><strong>7.4.</strong> We may permanently withdraw the <strong>online services </strong>or any part of it at any time in the future. Unless we are prevented from doing so, we will give you 30 days&rsquo; notice if we intend to do this. In the event of a full withdrawal of the <strong>online services</strong>, on expiry of such notice, these terms and conditions shall terminate and, if you are a <strong>client</strong>, we will provide you with all future <strong>reports </strong>by post or other means as detailed in the <strong>client terms and conditions</strong>, or as agreed between us in writing from time to time. In the event of a partial withdrawal of our <strong>online services</strong>, these terms and conditions shall continue to the extent applicable but, if you are a <strong>client </strong>and we are unable to continue with <strong>paperless delivery</strong>, we will provide you with all future <strong>reports </strong>by post or other means as detailed in the <strong>client terms and conditions </strong>or as agreed between us in writing from time to time.</p>\n<p><strong>7.5. </strong>You are responsible for the security of any data downloaded, printed or copied (in any format) from our <strong>online services</strong>.</p>\n<h2>8. Communications via the online services</h2>\n<p><strong>8.1.</strong>&nbsp;If you are a <strong>client</strong>, we will send an email each time a new <strong>report </strong>is available within the <strong>online services</strong>.</p>\n<p><strong>8.2.</strong> If you are a <strong>client</strong> and your reporting preference within the <strong>online services</strong> is set to <strong>paperless</strong> delivery (including where this preference is automatically applied during the registration process):</p>\n<p><strong>8.2.1.</strong> we will issue and display all relevant <strong>reports </strong>relating to your <strong>account(s) </strong>via the <strong>online services </strong>and will no longer send such <strong>reports </strong>to you by post or other means;</p>\n<p><strong>8.2.2.</strong> we will notify you by email whenever a new <strong>report </strong>or other document is available within the <strong>online services</strong>;</p>\n<p><strong>8.2.3.</strong> any communication we send to you through the <strong>online services </strong>will be valid and treated as having been received by you at the time we sent it;</p>\n<p><strong>8.2.4.</strong> any <strong>report </strong>relating to your <strong>account </strong>which we are required to deliver to you pursuant to our regulatory obligations will be deemed to have been provided in a durable medium in accordance with those regulatory obligations by us making such <strong>report </strong>available via the <strong>online services </strong>and notifying you of such availability by email as set out in these terms and conditions;</p>\n<p><strong>8.2.5.</strong> you must log into the <strong>online services </strong>and check your emails (including any junk or spam folders) for communications relating to your account regularly; and</p>\n<p><strong>8.2.6.</strong> if you subsequently amend your reporting preferences in the <strong>online services </strong>and opt-out of <strong>paperless</strong> <strong>delivery</strong>, we will revert to sending all future <strong>reports </strong>to you by post or other means as detailed in the <strong>client terms and conditions </strong>or as agreed between us in writing from time to time.</p>\n<p><strong>8.3.</strong> During the <strong>client</strong> registration process your reporting preference will automatically be set to <strong>paperless delivery</strong> by default. However, if you prefer to receive <strong>reports</strong> by post, you can change your reporting preferences at any time via your profile settings in the <strong>online services</strong>.</p>\n<p><strong>8.4.</strong> If you are a <strong>client</strong>, you can change your reporting preferences at any time via your profile settings in the <strong>online services</strong>. If you do so, the implementation of those changes will not be immediate but we will endeavour to make them as soon as reasonably possible.</p>\n<p><strong>8.5.</strong> If any <strong>report </strong>or information accessed or received by you via the <strong>online services </strong>is not intended for you, you must:</p>\n<p><strong>8.5.1.</strong> immediately notify us by email at <a href="mailto:Privacy@quiltercheviot.com"><strong>Privacy@quiltercheviot.com</strong></a>;</p>\n<p><strong>8.5.2.</strong> not access such information further and immediately delete any local copies you may hold; and</p>\n<p><strong>8.5.3.</strong> keep any information that was not intended for you confidential.</p>\n<h2>9. Linking to MyQuilterCheviot</h2>\n<p><strong>9.1.</strong> You must not establish a link to any part of <strong>MyQuilterCheviot </strong>in any website and <strong>MyQuilterCheviot </strong>may not be framed on any other website.</p>\n<h2>10. Changes to the agreement</h2>\n<p><strong>10.1.</strong> We may amend these terms and conditions to reflect a change in the law or to meet regulatory requirements. We may also amend them to reflect changes in technology, to cover an improvement or change in the <strong>online services </strong>or for any other valid reason.</p>\n<p><strong>10.2.</strong> If we do change these terms and conditions, we will notify you about the change the next time you attempt to log on to the <strong>online services </strong>and, before you are able to continue using the <strong>online services</strong>, you will need to view and agree to the changes. No attempt by you to amend these terms and conditions shall be valid unless we have agreed to such amendment in writing.</p>\n<p><strong>10.3.</strong> If you do not accept any changes to these terms and conditions, you will no longer be able to use the <strong>online services</strong>. If you remain the <strong>account operator </strong>and as a <strong>client </strong>had opted into <strong>paperless delivery</strong>, you should contact your investment manager who will ensure all future <strong>reports </strong>are sent to you by post. We may from time to time waive any term of these terms and conditions but, should we do so, it does not mean that we will do so again in the future.</p>\n<h2>11. Changes to the online services</h2>\n<p><strong>11.1.</strong> The layout, form, wording and functionality of the <strong>online services </strong>is subject to change by us.</p>\n<h2>12. Termination</h2>\n<p><strong>12.1.</strong> If you no longer wish to use and access the <strong>online services</strong>, you have the right to cancel your acceptance of these terms and conditions at any time in whole or in relation to any particular <strong>account</strong>, by writing to your or the <strong>client\'s</strong>&nbsp;investment manager.</p>\n<p><strong>12.2.</strong> Our right to terminate:</p>\n<p><strong>12.2.1.</strong> We may terminate or suspend your access to the <strong>online services </strong>at any time.</p>\n<p><strong>12.2.2.</strong> If we decide to terminate your access to the <strong>online services </strong>we shall give you at least 30 days&rsquo; notice unless clause 12.2.3 below applies;</p>\n<p><strong>12.2.3.</strong> We may terminate your access to the <strong>online services </strong>immediately if:</p>\n<p><strong>12.2.3.1.</strong> we have reason to believe you have given us false information or have acted dishonestly in your dealings with us;</p>\n<p><strong>12.2.3.2.</strong> we have reasonable grounds to suspect that you have authorised someone to use the <strong>online services </strong>with your <strong>security details </strong>without our consent, or there has been fraudulent or unauthorised use of your <strong>security details</strong>;</p>\n<p><strong>12.2.3.3.</strong> we have reasonable grounds to suspect that your <strong>security details </strong>have not been kept safe;</p>\n<p><strong>12.2.3.4.</strong> you are seriously or persistently in breach of these terms and conditions;</p>\n<p><strong>12.2.3.5.</strong> we need to do so in order to comply with our regulatory or legal obligations;</p>\n<p><strong>12.2.3.6.</strong> you are no longer the <strong>account operator </strong>or we are informed of your death or incapacity;</p>\n<p><strong>12.2.3.7.</strong> you are no longer a <strong>client</strong> or an <strong>adviser</strong>; or otherwise authorised to access the <strong>online services</strong>;</p>\n<p><strong>12.2.3.8.</strong> the relevant <strong>account </strong>is closed; or</p>\n<p><strong>12.2.3.9.</strong> where you are a <strong>master user</strong>, if we have reason to believe your access has been misused, or if you no longer meet the eligibility criteria to be a <strong>master user</strong>.</p>\n<p><strong>12.2.4.</strong> Unless we are prevented from doing so, we will use reasonable efforts to notify you in advance that we are terminating your access to the <strong>online services </strong>under clause 12.2.3.</p>\n<p><strong>12.3.</strong> The effect of termination</p>\n<p><strong>12.3.1.</strong> Your access to the <strong>online services </strong>shall be removed within a reasonable timescale determined by us in the circumstances and you will be responsible for printing or saving any of the data or <strong>reports </strong>available via the <strong>online services </strong>in advance of access being removed. Following termination of your access to the <strong>online services</strong>;</p>\n<p><strong>12.3.1.1.</strong> if you remain a <strong>client</strong>, we will send all future <strong>reports </strong>to you by post or otherwise in accordance with the <strong>client terms and conditions </strong>or as agreed between us in writing from time to time; or</p>\n<p><strong>12.3.1.2.</strong> if you are no longer a <strong>client </strong>(or otherwise an <strong>account operator</strong>) or the relevant <strong>account </strong>is closed, we may, on receipt of a request from you and subject to our legal and regulatory obligations, agree to provide you with paper copies of any <strong>reports </strong>or documents that were previously accessible via the <strong>online services.</strong></p>\n<p><strong>12.3.2.</strong> The termination of your access to the <strong>online services </strong>(however caused) will not, in any way, affect the validity of an <strong>account </strong>or the provision of our services in respect of it and you shall continue to be bound by the <strong>standard terms </strong>for as long as you remain a <strong>client</strong>, <strong>adviser </strong>or, to the extent applicable, an <strong>account operator</strong>.</p>\n<h2>13. Information technology failure and force majeure</h2>\n<p><strong>13.1.</strong> Provided we have complied with our regulatory obligations to have appropriate systems and controls in place to guard against breakdowns in our service, we shall not be liable for any failure to perform our obligations in accordance with these terms and conditions and/or to make the <strong>online services </strong>available if we are prevented from doing so by reason of:</p>\n<p><strong>13.1.1.</strong> failure outside our control of our information technology systems, provided that we have reasonable procedures in place by way of a disaster recovery programme and implement such procedures where necessary; or</p>\n<p><strong>13.1.2.</strong> other supervening acts outside of our control, for example:</p>\n<p><strong>13.1.2.1.</strong> any act (or credible threat) of terrorism;</p>\n<p><strong>13.1.2.2.</strong>&nbsp;acts of government, local authority or regulatory body;</p>\n<p><strong>13.1.2.3.</strong> explosion, fire, earthquake, extraordinary storm, flood, abnormal weather conditions or other natural disaster, epidemic or pandemic or any nuclear, chemical or biological contamination or any strikes, lockouts or other industrial disputes (other than to the extent involving our workforce);</p>\n<p><strong>13.1.2.4.</strong> riot, civil unrest, commotion or rebellion, war or civil war or armed conflict, invasion and acts of foreign enemies, blockades or embargoes;</p>\n<p><strong>13.1.2.5.</strong> an unavoidable accident;</p>\n<p><strong>13.1.2.6.</strong> the loss of supply of essential services including but not limited to electrical power and telecommunications;</p>\n<p><strong>13.1.2.7.</strong> any &lsquo;denial of service&rsquo; or other targeted network attack; and</p>\n<p><strong>13.1.2.8.</strong> any other cause beyond our reasonable control as a consequence of which we can no longer provide the <strong>online services </strong>for a given period.</p>\n<p><strong>13.1.3.</strong> We will take all reasonable steps to minimise any delay or disruption to the availability of the <strong>online services </strong>if we are prevented from making the <strong>online services </strong>available because of any of the events or acts in 13.1.1 and/or 13.1.2 above.</p>\n<h2>14. Intellectual property</h2>\n<p><strong>14.1.</strong> All material contained within the <strong>online services </strong>and our <strong>website </strong>is copyright of ours or third parties who have granted us a licence to use such material. Information accessed through the <strong>online services </strong>or our <strong>website </strong>is protected under copyright law and you may not copy, re-publish or re-distribute such information for commercial purposes without our prior written consent or as is otherwise expressly permitted under these terms and conditions.</p>\n<p><strong>14.2.</strong> The <strong>online services </strong>and our <strong>website </strong>contain names and logos which are our trademarks or those of third parties who have granted us a right to use such trademarks. Any use of these names or logos without our authorisation would constitute an infringement of those trademarks and is not permitted.</p>\n<h2>15. Data</h2>\n<p><strong>15.1.&nbsp;</strong><strong>Reports </strong>and other data held in the <strong>online services </strong>are subject to our internal record keeping arrangements and retention and erasure policies. As with all data provided to you, you can retain copies of your own records. We may delete <strong>reports </strong>and any other data held in the <strong>online services </strong>in accordance with our standard record retention policies. If any such data is important to you, you should print it or save it to your own device.</p>\n<p><strong>15.2.</strong> Any <strong>personal data </strong>contained within, or transmitted via, the <strong>online services </strong>shall be processed in accordance with the <strong>standard terms </strong>and our <strong>privacy notice</strong>.</p>\n<p><strong>15.3.</strong> Access to <strong>personal data </strong>via the <strong>online services </strong>is strictly limited to individuals with appropriate authorisation. We implement reasonable technical and organisational measures to support appropriate access to <strong>personal data </strong>via the <strong>online services</strong>, including role-based access controls. We rely on authorised users of third-party firms to manage <strong>user </strong>access within their organisations and to notify us promptly of any changes in <strong>user </strong>authorisation. While we take steps to support secure access, we do not guarantee that access controls will prevent all unauthorised access. <strong>Master users </strong>must ensure that access rights are reviewed regularly and revoked promptly when no longer required.</p>\n<p><strong>15.4.</strong>&nbsp;The <strong>online services </strong>may use cookies and, any such use, shall be in accordance with our <strong>cookies policy</strong>.&nbsp;If you require more information about the processing of any data within the <strong>online services </strong>you should contact our Data Guardian by email at <a href="mailto:Privacy@quiltercheviot.com"><strong>Privacy@quiltercheviot.com</strong></a><strong> </strong>or by post at Data Guardian, Quilter Cheviot Limited, Sunderland, SR43 4JP.</p>\n<p><strong>15.5.</strong> Where an <strong>adviser </strong>or <strong>master user </strong>accesses <strong>personal data</strong>, such access shall be logged. The <strong>adviser </strong>or <strong>master user </strong>is responsible for ensuring that <strong>personal data </strong>accessed is handled in accordance with our <strong>privacy notice</strong>, <strong>applicable data protections laws</strong>, and the <strong>introducer terms of business</strong>. This includes:</p>\n<p><strong>15.5.1.</strong> Ensuring a lawful basis for processing <strong>personal data</strong>;</p>\n<p><strong>15.5.2.</strong> Adhering to data minimisation and purpose limitation;</p>\n<p><strong>15.5.3.</strong> Promptly reporting any <strong>personal data </strong>breaches;</p>\n<p><strong>15.5.4.</strong> Complying with safeguards for automated decision-making under the Data (Use and Access) Act 2025 (proposed legislation governing automated data processing in the UK) and EU GDPR.</p>\n<p><strong>15.6.</strong> <strong>Master users </strong>must maintain an internal audit trail of <strong>user </strong>access they grant to the <strong>online services</strong>. We reserve the right to request such records for compliance or regulatory purposes.</p>\n<h2>16. Third party rights</h2>\n<p><strong>16.1.</strong> Only you and we are able to enforce these terms and conditions.</p>\n<h2>17. Severance</h2>\n<p><strong>17.1.</strong> If any provision (or a part thereof) of these terms and conditions is or becomes invalid, illegal or unenforceable, it shall be deemed deleted, but that shall not affect the validity and enforceability of the rest of these terms and conditions.</p>\n<h2>18. Transferring this agreement</h2>\n<p><strong>18.1.</strong> We may transfer our rights and obligations under these terms and conditions to another organisation. We will always tell you in writing if this happens and we will ensure that the transfer will not affect your rights under these terms and conditions.</p>\n<h2>19. Relevant law</h2>\n<p><strong>19.1.</strong>&nbsp;These terms and conditions are to be interpreted in accordance with and are governed by English law. You and we agree that the courts of England and Wales shall have exclusive jurisdiction to resolve any dispute arising under these terms and conditions (whether relating to the subject matter or formation of them), except that if you are a resident of Northern Ireland you may also bring proceedings in Northern Ireland, and if you are a resident of Scotland, you may also bring proceedings in Scotland.</p>\n<p>July 2026</p>',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Transactions.Assets.Search.Short.Text',
    value: 'Search by description or ref',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Transactions.Assets.Search.Text',
    value: 'Search by reference or description',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Transactions.Cash.Search.Short.Text',
    value: 'Search by description or ref',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Transactions.Cash.Search.Text',
    value: 'Search by reference or description',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Valuation.Summary.ShortTimeframeWarning.Info.Text',
    value:
      'You have selected to review your investment performance over a short time period. Investing should generally be for the longer term. Performance over shorter timescales could be influenced by short-term volatility. If you have any questions, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ValuationSettings.TotalValuation.Info.Text',
    value:
      'If you are associated with multiple portfolios you can opt to exclude any individual portfolio from the total valuations as displayed on your homepage. You must include at least one portfolio in the valuation total and excluded portfolios will be shown in a separate section on your homepage.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'ValuationSummaryHeader.ValuationDate.Info',
    value:
      'All values are based on the mid-market price at the close of business on the date shown, converted into the valuation currency where appropriate. Prices can be updated intra-day but may not be reflected here until the following day. If you have any questions, please contact your investment manager.',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Feedback.Link',
    value: 'https://www.surveymonkey.com/r/NLDWSV2',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Feedback.Text',
    value: 'Leave feedback',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link0.Link',
    value: 'https://www.quiltercheviot.com/contact-us/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link0.Text',
    value: 'Contact Quilter Cheviot',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link1.Link',
    value:
      'https://www.quiltercheviot.com/supporting-clients-with-additional-needs/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link1.Text',
    value: 'Supporting clients with additional needs',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link2.Link',
    value: 'https://www.quiltercheviot.com/myqc/support',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link2.Text',
    value: 'Frequently Asked Questions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link3.Link',
    value:
      'https://www.quiltercheviot.com/siteassets/documents/terms-and-conditions/qc-online-services-terms-and-conditions.pdf',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link3.Text',
    value: 'Online Services Terms &amp; Conditions',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link4.Link',
    value: 'https://www.quiltercheviot.com/online-services-cookies-notice/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link4.Text',
    value: 'Online Services cookies notice',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link5.Link',
    value:
      'https://www.quiltercheviot.com/important-information/privacy-notice/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link5.Text',
    value: 'Privacy notice',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link6.Link',
    value:
      'https://www.quiltercheviot.com/important-information/corporate-and-regulatory-information/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link6.Text',
    value: 'Corporate and regulatory information',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link7.Link',
    value:
      'https://www.quiltercheviot.com/important-information/accessibility/',
    group: null,
  },
  {
    tool: 'DXPGlobal',
    key: 'Web.Navigation.Footer.Link7.Text',
    value: 'Accessibility',
    group: null,
  },
] as const
